// source: fitness-service/v1/workout.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var fitness$service_v1_client_pb = require('../../fitness-service/v1/client_pb.js');
goog.object.extend(proto, fitness$service_v1_client_pb);
var fitness$service_v1_exercise_pb = require('../../fitness-service/v1/exercise_pb.js');
goog.object.extend(proto, fitness$service_v1_exercise_pb);
goog.exportSymbol('proto.fitness.service.v1.ClientProgress', null, global);
goog.exportSymbol('proto.fitness.service.v1.ClientStats', null, global);
goog.exportSymbol('proto.fitness.service.v1.CompleteWorkoutSessionRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.CompleteWorkoutSessionResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.CreateDailyWorkout', null, global);
goog.exportSymbol('proto.fitness.service.v1.CreateDailyWorkoutExercise', null, global);
goog.exportSymbol('proto.fitness.service.v1.CreateWorkoutPlanExercise', null, global);
goog.exportSymbol('proto.fitness.service.v1.CreateWorkoutPlanRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.CreateWorkoutPlanResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.DailyWorkout', null, global);
goog.exportSymbol('proto.fitness.service.v1.DailyWorkoutExercise', null, global);
goog.exportSymbol('proto.fitness.service.v1.DayVolume', null, global);
goog.exportSymbol('proto.fitness.service.v1.DeleteDailyWorkoutRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.DeleteDailyWorkoutResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.DeleteWorkoutPlanRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.DeleteWorkoutPlanResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.ExercisePoint', null, global);
goog.exportSymbol('proto.fitness.service.v1.ExerciseProgress', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetClientProgressRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetClientProgressResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetDailyWorkoutRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetDailyWorkoutResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetDailyWorkoutsRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetDailyWorkoutsResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetGroupProgressRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetGroupProgressResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetRosterProgressRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetRosterProgressResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetWorkoutPlanRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetWorkoutPlanResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetWorkoutPlansRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetWorkoutPlansResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetWorkoutSessionRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetWorkoutSessionResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetWorkoutSessionsRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetWorkoutSessionsResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetWorkoutStatsRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.GetWorkoutStatsResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.LogSet', null, global);
goog.exportSymbol('proto.fitness.service.v1.PlanTypeStats', null, global);
goog.exportSymbol('proto.fitness.service.v1.StartWorkoutSessionRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.StartWorkoutSessionResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateDailyWorkoutExercise', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateDailyWorkoutRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateDailyWorkoutResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateWorkoutPlanExercise', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateWorkoutPlanRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateWorkoutPlanResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateWorkoutSessionRequest', null, global);
goog.exportSymbol('proto.fitness.service.v1.UpdateWorkoutSessionResponse', null, global);
goog.exportSymbol('proto.fitness.service.v1.WorkoutPlan', null, global);
goog.exportSymbol('proto.fitness.service.v1.WorkoutPlanExercise', null, global);
goog.exportSymbol('proto.fitness.service.v1.WorkoutSession', null, global);
goog.exportSymbol('proto.fitness.service.v1.WorkoutSet', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.WorkoutPlan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.WorkoutPlan.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.WorkoutPlan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.WorkoutPlan.displayName = 'proto.fitness.service.v1.WorkoutPlan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DailyWorkout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.DailyWorkout.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.DailyWorkout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DailyWorkout.displayName = 'proto.fitness.service.v1.DailyWorkout';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DailyWorkoutExercise = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DailyWorkoutExercise, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DailyWorkoutExercise.displayName = 'proto.fitness.service.v1.DailyWorkoutExercise';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.WorkoutPlanExercise = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.WorkoutPlanExercise, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.WorkoutPlanExercise.displayName = 'proto.fitness.service.v1.WorkoutPlanExercise';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.CreateWorkoutPlanRequest.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.CreateWorkoutPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateWorkoutPlanRequest.displayName = 'proto.fitness.service.v1.CreateWorkoutPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateDailyWorkout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.CreateDailyWorkout.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.CreateDailyWorkout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateDailyWorkout.displayName = 'proto.fitness.service.v1.CreateDailyWorkout';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.CreateDailyWorkoutExercise, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateDailyWorkoutExercise.displayName = 'proto.fitness.service.v1.CreateDailyWorkoutExercise';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.CreateWorkoutPlanExercise, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateWorkoutPlanExercise.displayName = 'proto.fitness.service.v1.CreateWorkoutPlanExercise';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.CreateWorkoutPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CreateWorkoutPlanResponse.displayName = 'proto.fitness.service.v1.CreateWorkoutPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetWorkoutPlansRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetWorkoutPlansRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetWorkoutPlansRequest.displayName = 'proto.fitness.service.v1.GetWorkoutPlansRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetWorkoutPlansResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetWorkoutPlansResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetWorkoutPlansResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetWorkoutPlansResponse.displayName = 'proto.fitness.service.v1.GetWorkoutPlansResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetWorkoutPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetWorkoutPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetWorkoutPlanRequest.displayName = 'proto.fitness.service.v1.GetWorkoutPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetWorkoutPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetWorkoutPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetWorkoutPlanResponse.displayName = 'proto.fitness.service.v1.GetWorkoutPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.UpdateWorkoutPlanRequest.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.UpdateWorkoutPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateWorkoutPlanRequest.displayName = 'proto.fitness.service.v1.UpdateWorkoutPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateWorkoutPlanExercise, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateWorkoutPlanExercise.displayName = 'proto.fitness.service.v1.UpdateWorkoutPlanExercise';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateWorkoutPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateWorkoutPlanResponse.displayName = 'proto.fitness.service.v1.UpdateWorkoutPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DeleteWorkoutPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DeleteWorkoutPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DeleteWorkoutPlanRequest.displayName = 'proto.fitness.service.v1.DeleteWorkoutPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DeleteWorkoutPlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DeleteWorkoutPlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DeleteWorkoutPlanResponse.displayName = 'proto.fitness.service.v1.DeleteWorkoutPlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetDailyWorkoutsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetDailyWorkoutsRequest.displayName = 'proto.fitness.service.v1.GetDailyWorkoutsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetDailyWorkoutsResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetDailyWorkoutsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetDailyWorkoutsResponse.displayName = 'proto.fitness.service.v1.GetDailyWorkoutsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetDailyWorkoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetDailyWorkoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetDailyWorkoutRequest.displayName = 'proto.fitness.service.v1.GetDailyWorkoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetDailyWorkoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetDailyWorkoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetDailyWorkoutResponse.displayName = 'proto.fitness.service.v1.GetDailyWorkoutResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.UpdateDailyWorkoutRequest.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.UpdateDailyWorkoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateDailyWorkoutRequest.displayName = 'proto.fitness.service.v1.UpdateDailyWorkoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateDailyWorkoutExercise, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateDailyWorkoutExercise.displayName = 'proto.fitness.service.v1.UpdateDailyWorkoutExercise';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateDailyWorkoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateDailyWorkoutResponse.displayName = 'proto.fitness.service.v1.UpdateDailyWorkoutResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DeleteDailyWorkoutRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DeleteDailyWorkoutRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DeleteDailyWorkoutRequest.displayName = 'proto.fitness.service.v1.DeleteDailyWorkoutRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DeleteDailyWorkoutResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DeleteDailyWorkoutResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DeleteDailyWorkoutResponse.displayName = 'proto.fitness.service.v1.DeleteDailyWorkoutResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetWorkoutStatsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetWorkoutStatsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetWorkoutStatsRequest.displayName = 'proto.fitness.service.v1.GetWorkoutStatsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetWorkoutStatsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetWorkoutStatsResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetWorkoutStatsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetWorkoutStatsResponse.displayName = 'proto.fitness.service.v1.GetWorkoutStatsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.ClientStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.ClientStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.ClientStats.displayName = 'proto.fitness.service.v1.ClientStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.PlanTypeStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.PlanTypeStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.PlanTypeStats.displayName = 'proto.fitness.service.v1.PlanTypeStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.WorkoutSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.WorkoutSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.WorkoutSet.displayName = 'proto.fitness.service.v1.WorkoutSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.WorkoutSession = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.WorkoutSession.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.WorkoutSession, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.WorkoutSession.displayName = 'proto.fitness.service.v1.WorkoutSession';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.StartWorkoutSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.StartWorkoutSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.StartWorkoutSessionRequest.displayName = 'proto.fitness.service.v1.StartWorkoutSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.StartWorkoutSessionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.StartWorkoutSessionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.StartWorkoutSessionResponse.displayName = 'proto.fitness.service.v1.StartWorkoutSessionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.LogSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.LogSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.LogSet.displayName = 'proto.fitness.service.v1.LogSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.UpdateWorkoutSessionRequest.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.UpdateWorkoutSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateWorkoutSessionRequest.displayName = 'proto.fitness.service.v1.UpdateWorkoutSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.UpdateWorkoutSessionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.UpdateWorkoutSessionResponse.displayName = 'proto.fitness.service.v1.UpdateWorkoutSessionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.CompleteWorkoutSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CompleteWorkoutSessionRequest.displayName = 'proto.fitness.service.v1.CompleteWorkoutSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.CompleteWorkoutSessionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.CompleteWorkoutSessionResponse.displayName = 'proto.fitness.service.v1.CompleteWorkoutSessionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetWorkoutSessionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetWorkoutSessionsRequest.displayName = 'proto.fitness.service.v1.GetWorkoutSessionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetWorkoutSessionsResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetWorkoutSessionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetWorkoutSessionsResponse.displayName = 'proto.fitness.service.v1.GetWorkoutSessionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetWorkoutSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetWorkoutSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetWorkoutSessionRequest.displayName = 'proto.fitness.service.v1.GetWorkoutSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetWorkoutSessionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetWorkoutSessionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetWorkoutSessionResponse.displayName = 'proto.fitness.service.v1.GetWorkoutSessionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.ExerciseProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.ExerciseProgress.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.ExerciseProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.ExerciseProgress.displayName = 'proto.fitness.service.v1.ExerciseProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.ExercisePoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.ExercisePoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.ExercisePoint.displayName = 'proto.fitness.service.v1.ExercisePoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.ClientProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.ClientProgress.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.ClientProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.ClientProgress.displayName = 'proto.fitness.service.v1.ClientProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.DayVolume = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.DayVolume, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.DayVolume.displayName = 'proto.fitness.service.v1.DayVolume';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetClientProgressRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetClientProgressRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetClientProgressRequest.displayName = 'proto.fitness.service.v1.GetClientProgressRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetClientProgressResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetClientProgressResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetClientProgressResponse.displayName = 'proto.fitness.service.v1.GetClientProgressResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetGroupProgressRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetGroupProgressRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetGroupProgressRequest.displayName = 'proto.fitness.service.v1.GetGroupProgressRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetGroupProgressResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetGroupProgressResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetGroupProgressResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetGroupProgressResponse.displayName = 'proto.fitness.service.v1.GetGroupProgressResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetRosterProgressRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fitness.service.v1.GetRosterProgressRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetRosterProgressRequest.displayName = 'proto.fitness.service.v1.GetRosterProgressRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fitness.service.v1.GetRosterProgressResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fitness.service.v1.GetRosterProgressResponse.repeatedFields_, null);
};
goog.inherits(proto.fitness.service.v1.GetRosterProgressResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fitness.service.v1.GetRosterProgressResponse.displayName = 'proto.fitness.service.v1.GetRosterProgressResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.WorkoutPlan.repeatedFields_ = [15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.WorkoutPlan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.WorkoutPlan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.WorkoutPlan.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
trainerId: jspb.Message.getFieldWithDefault(msg, 4, ""),
clientId: jspb.Message.getFieldWithDefault(msg, 5, ""),
startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
isActive: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
goals: jspb.Message.getFieldWithDefault(msg, 9, ""),
notes: jspb.Message.getFieldWithDefault(msg, 10, ""),
difficulty: jspb.Message.getFieldWithDefault(msg, 11, ""),
planType: jspb.Message.getFieldWithDefault(msg, 12, ""),
dailyWorkoutsList: jspb.Message.toObjectList(msg.getDailyWorkoutsList(),
    proto.fitness.service.v1.DailyWorkout.toObject, includeInstance),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
trainer: (f = msg.getTrainer()) && fitness$service_v1_client_pb.TrainerInfo.toObject(includeInstance, f),
client: (f = msg.getClient()) && fitness$service_v1_client_pb.ClientInfo.toObject(includeInstance, f),
sourceTemplateId: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.WorkoutPlan}
 */
proto.fitness.service.v1.WorkoutPlan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.WorkoutPlan;
  return proto.fitness.service.v1.WorkoutPlan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.WorkoutPlan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.WorkoutPlan}
 */
proto.fitness.service.v1.WorkoutPlan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTrainerId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGoals(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDifficulty(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPlanType(value);
      break;
    case 15:
      var value = new proto.fitness.service.v1.DailyWorkout;
      reader.readMessage(value,proto.fitness.service.v1.DailyWorkout.deserializeBinaryFromReader);
      msg.addDailyWorkouts(value);
      break;
    case 16:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 18:
      var value = new fitness$service_v1_client_pb.TrainerInfo;
      reader.readMessage(value,fitness$service_v1_client_pb.TrainerInfo.deserializeBinaryFromReader);
      msg.setTrainer(value);
      break;
    case 19:
      var value = new fitness$service_v1_client_pb.ClientInfo;
      reader.readMessage(value,fitness$service_v1_client_pb.ClientInfo.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSourceTemplateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.WorkoutPlan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.WorkoutPlan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.WorkoutPlan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTrainerId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getGoals();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDifficulty();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPlanType();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getDailyWorkoutsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      proto.fitness.service.v1.DailyWorkout.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTrainer();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      fitness$service_v1_client_pb.TrainerInfo.serializeBinaryToWriter
    );
  }
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      fitness$service_v1_client_pb.ClientInfo.serializeBinaryToWriter
    );
  }
  f = message.getSourceTemplateId();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string trainer_id = 4;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getTrainerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.setTrainerId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string client_id = 5;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp start_date = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
*/
proto.fitness.service.v1.WorkoutPlan.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
*/
proto.fitness.service.v1.WorkoutPlan.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool is_active = 8;
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string goals = 9;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getGoals = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.setGoals = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string notes = 10;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string difficulty = 11;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getDifficulty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string plan_type = 12;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getPlanType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.setPlanType = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated DailyWorkout daily_workouts = 15;
 * @return {!Array<!proto.fitness.service.v1.DailyWorkout>}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getDailyWorkoutsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.DailyWorkout>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.DailyWorkout, 15));
};


/**
 * @param {!Array<!proto.fitness.service.v1.DailyWorkout>} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
*/
proto.fitness.service.v1.WorkoutPlan.prototype.setDailyWorkoutsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.fitness.service.v1.DailyWorkout=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.DailyWorkout}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.addDailyWorkouts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.fitness.service.v1.DailyWorkout, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.clearDailyWorkoutsList = function() {
  return this.setDailyWorkoutsList([]);
};


/**
 * optional google.protobuf.Timestamp created_at = 16;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 16));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
*/
proto.fitness.service.v1.WorkoutPlan.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
*/
proto.fitness.service.v1.WorkoutPlan.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional TrainerInfo trainer = 18;
 * @return {?proto.fitness.service.v1.TrainerInfo}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getTrainer = function() {
  return /** @type{?proto.fitness.service.v1.TrainerInfo} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_client_pb.TrainerInfo, 18));
};


/**
 * @param {?proto.fitness.service.v1.TrainerInfo|undefined} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
*/
proto.fitness.service.v1.WorkoutPlan.prototype.setTrainer = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.clearTrainer = function() {
  return this.setTrainer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.hasTrainer = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional ClientInfo client = 19;
 * @return {?proto.fitness.service.v1.ClientInfo}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getClient = function() {
  return /** @type{?proto.fitness.service.v1.ClientInfo} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_client_pb.ClientInfo, 19));
};


/**
 * @param {?proto.fitness.service.v1.ClientInfo|undefined} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
*/
proto.fitness.service.v1.WorkoutPlan.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.hasClient = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional string source_template_id = 20;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlan.prototype.getSourceTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlan} returns this
 */
proto.fitness.service.v1.WorkoutPlan.prototype.setSourceTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.DailyWorkout.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DailyWorkout.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DailyWorkout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DailyWorkout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DailyWorkout.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
workoutPlanId: jspb.Message.getFieldWithDefault(msg, 2, ""),
dayNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
dayOfWeek: jspb.Message.getFieldWithDefault(msg, 4, ""),
workoutDate: (f = msg.getWorkoutDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
title: jspb.Message.getFieldWithDefault(msg, 6, ""),
description: jspb.Message.getFieldWithDefault(msg, 7, ""),
estimatedDuration: jspb.Message.getFieldWithDefault(msg, 8, 0),
isRestDay: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
notes: jspb.Message.getFieldWithDefault(msg, 10, ""),
exercisesList: jspb.Message.toObjectList(msg.getExercisesList(),
    proto.fitness.service.v1.DailyWorkoutExercise.toObject, includeInstance),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
sessionNumber: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DailyWorkout}
 */
proto.fitness.service.v1.DailyWorkout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DailyWorkout;
  return proto.fitness.service.v1.DailyWorkout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DailyWorkout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DailyWorkout}
 */
proto.fitness.service.v1.DailyWorkout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkoutPlanId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDayNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDayOfWeek(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWorkoutDate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTitle(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedDuration(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRestDay(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 11:
      var value = new proto.fitness.service.v1.DailyWorkoutExercise;
      reader.readMessage(value,proto.fitness.service.v1.DailyWorkoutExercise.deserializeBinaryFromReader);
      msg.addExercises(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSessionNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DailyWorkout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DailyWorkout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DailyWorkout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DailyWorkout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkoutPlanId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDayNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDayOfWeek();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getWorkoutDate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEstimatedDuration();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getIsRestDay();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getExercisesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.fitness.service.v1.DailyWorkoutExercise.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSessionNumber();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string workout_plan_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getWorkoutPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.setWorkoutPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 day_number = 3;
 * @return {number}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getDayNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.setDayNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string day_of_week = 4;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getDayOfWeek = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.setDayOfWeek = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp workout_date = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getWorkoutDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
*/
proto.fitness.service.v1.DailyWorkout.prototype.setWorkoutDate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.clearWorkoutDate = function() {
  return this.setWorkoutDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.DailyWorkout.prototype.hasWorkoutDate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string title = 6;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 estimated_duration = 8;
 * @return {number}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getEstimatedDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.setEstimatedDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool is_rest_day = 9;
 * @return {boolean}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getIsRestDay = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.setIsRestDay = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional string notes = 10;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated DailyWorkoutExercise exercises = 11;
 * @return {!Array<!proto.fitness.service.v1.DailyWorkoutExercise>}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getExercisesList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.DailyWorkoutExercise>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.DailyWorkoutExercise, 11));
};


/**
 * @param {!Array<!proto.fitness.service.v1.DailyWorkoutExercise>} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
*/
proto.fitness.service.v1.DailyWorkout.prototype.setExercisesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.fitness.service.v1.DailyWorkoutExercise=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise}
 */
proto.fitness.service.v1.DailyWorkout.prototype.addExercises = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.fitness.service.v1.DailyWorkoutExercise, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.clearExercisesList = function() {
  return this.setExercisesList([]);
};


/**
 * optional google.protobuf.Timestamp created_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
*/
proto.fitness.service.v1.DailyWorkout.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.DailyWorkout.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
*/
proto.fitness.service.v1.DailyWorkout.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.DailyWorkout.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional int32 session_number = 14;
 * @return {number}
 */
proto.fitness.service.v1.DailyWorkout.prototype.getSessionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.DailyWorkout} returns this
 */
proto.fitness.service.v1.DailyWorkout.prototype.setSessionNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DailyWorkoutExercise.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DailyWorkoutExercise} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DailyWorkoutExercise.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
dailyWorkoutId: jspb.Message.getFieldWithDefault(msg, 2, ""),
exerciseId: jspb.Message.getFieldWithDefault(msg, 3, ""),
orderIndex: jspb.Message.getFieldWithDefault(msg, 4, 0),
sets: jspb.Message.getFieldWithDefault(msg, 5, 0),
reps: jspb.Message.getFieldWithDefault(msg, 6, ""),
weight: jspb.Message.getFieldWithDefault(msg, 7, ""),
restTime: jspb.Message.getFieldWithDefault(msg, 8, ""),
notes: jspb.Message.getFieldWithDefault(msg, 9, ""),
isSuperset: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
supersetGroup: jspb.Message.getFieldWithDefault(msg, 11, 0),
isWarmup: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
isCooldown: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
exercise: (f = msg.getExercise()) && fitness$service_v1_exercise_pb.Exercise.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise}
 */
proto.fitness.service.v1.DailyWorkoutExercise.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DailyWorkoutExercise;
  return proto.fitness.service.v1.DailyWorkoutExercise.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DailyWorkoutExercise} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise}
 */
proto.fitness.service.v1.DailyWorkoutExercise.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDailyWorkoutId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderIndex(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSets(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReps(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWeight(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRestTime(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuperset(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSupersetGroup(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsWarmup(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCooldown(value);
      break;
    case 14:
      var value = new fitness$service_v1_exercise_pb.Exercise;
      reader.readMessage(value,fitness$service_v1_exercise_pb.Exercise.deserializeBinaryFromReader);
      msg.setExercise(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DailyWorkoutExercise.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DailyWorkoutExercise} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DailyWorkoutExercise.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDailyWorkoutId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrderIndex();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSets();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getReps();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWeight();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRestTime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIsSuperset();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getSupersetGroup();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getIsWarmup();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIsCooldown();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getExercise();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      fitness$service_v1_exercise_pb.Exercise.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string daily_workout_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getDailyWorkoutId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setDailyWorkoutId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string exercise_id = 3;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 order_index = 4;
 * @return {number}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getOrderIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setOrderIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 sets = 5;
 * @return {number}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getSets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setSets = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string reps = 6;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getReps = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setReps = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string weight = 7;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getWeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setWeight = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string rest_time = 8;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getRestTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setRestTime = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string notes = 9;
 * @return {string}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool is_superset = 10;
 * @return {boolean}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getIsSuperset = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setIsSuperset = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int32 superset_group = 11;
 * @return {number}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getSupersetGroup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setSupersetGroup = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional bool is_warmup = 12;
 * @return {boolean}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getIsWarmup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setIsWarmup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool is_cooldown = 13;
 * @return {boolean}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getIsCooldown = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setIsCooldown = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional Exercise exercise = 14;
 * @return {?proto.fitness.service.v1.Exercise}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.getExercise = function() {
  return /** @type{?proto.fitness.service.v1.Exercise} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_exercise_pb.Exercise, 14));
};


/**
 * @param {?proto.fitness.service.v1.Exercise|undefined} value
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
*/
proto.fitness.service.v1.DailyWorkoutExercise.prototype.setExercise = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.DailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.clearExercise = function() {
  return this.setExercise(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.DailyWorkoutExercise.prototype.hasExercise = function() {
  return jspb.Message.getField(this, 14) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.WorkoutPlanExercise.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.WorkoutPlanExercise} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.WorkoutPlanExercise.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
workoutPlanId: jspb.Message.getFieldWithDefault(msg, 2, ""),
exerciseId: jspb.Message.getFieldWithDefault(msg, 3, ""),
orderIndex: jspb.Message.getFieldWithDefault(msg, 4, 0),
sets: jspb.Message.getFieldWithDefault(msg, 5, 0),
reps: jspb.Message.getFieldWithDefault(msg, 6, ""),
weight: jspb.Message.getFieldWithDefault(msg, 7, ""),
restTime: jspb.Message.getFieldWithDefault(msg, 8, ""),
notes: jspb.Message.getFieldWithDefault(msg, 9, ""),
isSuperset: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
supersetGroup: jspb.Message.getFieldWithDefault(msg, 11, 0),
exercise: (f = msg.getExercise()) && fitness$service_v1_exercise_pb.Exercise.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise}
 */
proto.fitness.service.v1.WorkoutPlanExercise.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.WorkoutPlanExercise;
  return proto.fitness.service.v1.WorkoutPlanExercise.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.WorkoutPlanExercise} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise}
 */
proto.fitness.service.v1.WorkoutPlanExercise.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkoutPlanId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderIndex(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSets(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReps(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWeight(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRestTime(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuperset(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSupersetGroup(value);
      break;
    case 12:
      var value = new fitness$service_v1_exercise_pb.Exercise;
      reader.readMessage(value,fitness$service_v1_exercise_pb.Exercise.deserializeBinaryFromReader);
      msg.setExercise(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.WorkoutPlanExercise.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.WorkoutPlanExercise} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.WorkoutPlanExercise.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkoutPlanId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrderIndex();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSets();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getReps();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWeight();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRestTime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIsSuperset();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getSupersetGroup();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getExercise();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      fitness$service_v1_exercise_pb.Exercise.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string workout_plan_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getWorkoutPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setWorkoutPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string exercise_id = 3;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 order_index = 4;
 * @return {number}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getOrderIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setOrderIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 sets = 5;
 * @return {number}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getSets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setSets = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string reps = 6;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getReps = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setReps = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string weight = 7;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getWeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setWeight = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string rest_time = 8;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getRestTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setRestTime = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string notes = 9;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool is_superset = 10;
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getIsSuperset = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setIsSuperset = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int32 superset_group = 11;
 * @return {number}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getSupersetGroup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setSupersetGroup = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional Exercise exercise = 12;
 * @return {?proto.fitness.service.v1.Exercise}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.getExercise = function() {
  return /** @type{?proto.fitness.service.v1.Exercise} */ (
    jspb.Message.getWrapperField(this, fitness$service_v1_exercise_pb.Exercise, 12));
};


/**
 * @param {?proto.fitness.service.v1.Exercise|undefined} value
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
*/
proto.fitness.service.v1.WorkoutPlanExercise.prototype.setExercise = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.WorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.clearExercise = function() {
  return this.setExercise(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutPlanExercise.prototype.hasExercise = function() {
  return jspb.Message.getField(this, 12) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateWorkoutPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateWorkoutPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
description: jspb.Message.getFieldWithDefault(msg, 2, ""),
clientId: jspb.Message.getFieldWithDefault(msg, 3, ""),
startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
goals: jspb.Message.getFieldWithDefault(msg, 5, ""),
notes: jspb.Message.getFieldWithDefault(msg, 6, ""),
difficulty: jspb.Message.getFieldWithDefault(msg, 7, ""),
planType: jspb.Message.getFieldWithDefault(msg, 8, ""),
dailyWorkoutsList: jspb.Message.toObjectList(msg.getDailyWorkoutsList(),
    proto.fitness.service.v1.CreateDailyWorkout.toObject, includeInstance),
sourceTemplateId: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateWorkoutPlanRequest;
  return proto.fitness.service.v1.CreateWorkoutPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateWorkoutPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGoals(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDifficulty(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPlanType(value);
      break;
    case 9:
      var value = new proto.fitness.service.v1.CreateDailyWorkout;
      reader.readMessage(value,proto.fitness.service.v1.CreateDailyWorkout.deserializeBinaryFromReader);
      msg.addDailyWorkouts(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSourceTemplateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateWorkoutPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateWorkoutPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getGoals();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDifficulty();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPlanType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDailyWorkoutsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.fitness.service.v1.CreateDailyWorkout.serializeBinaryToWriter
    );
  }
  f = message.getSourceTemplateId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string client_id = 3;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp start_date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
*/
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string goals = 5;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.getGoals = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.setGoals = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string difficulty = 7;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.getDifficulty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string plan_type = 8;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.getPlanType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.setPlanType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated CreateDailyWorkout daily_workouts = 9;
 * @return {!Array<!proto.fitness.service.v1.CreateDailyWorkout>}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.getDailyWorkoutsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.CreateDailyWorkout>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.CreateDailyWorkout, 9));
};


/**
 * @param {!Array<!proto.fitness.service.v1.CreateDailyWorkout>} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
*/
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.setDailyWorkoutsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.fitness.service.v1.CreateDailyWorkout=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.CreateDailyWorkout}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.addDailyWorkouts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.fitness.service.v1.CreateDailyWorkout, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.clearDailyWorkoutsList = function() {
  return this.setDailyWorkoutsList([]);
};


/**
 * optional string source_template_id = 10;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.getSourceTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanRequest.prototype.setSourceTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.CreateDailyWorkout.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateDailyWorkout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateDailyWorkout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateDailyWorkout.toObject = function(includeInstance, msg) {
  var f, obj = {
dayNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
dayOfWeek: jspb.Message.getFieldWithDefault(msg, 2, ""),
workoutDate: (f = msg.getWorkoutDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
title: jspb.Message.getFieldWithDefault(msg, 4, ""),
description: jspb.Message.getFieldWithDefault(msg, 5, ""),
estimatedDuration: jspb.Message.getFieldWithDefault(msg, 6, 0),
isRestDay: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
notes: jspb.Message.getFieldWithDefault(msg, 8, ""),
exercisesList: jspb.Message.toObjectList(msg.getExercisesList(),
    proto.fitness.service.v1.CreateDailyWorkoutExercise.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateDailyWorkout}
 */
proto.fitness.service.v1.CreateDailyWorkout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateDailyWorkout;
  return proto.fitness.service.v1.CreateDailyWorkout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateDailyWorkout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateDailyWorkout}
 */
proto.fitness.service.v1.CreateDailyWorkout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDayNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDayOfWeek(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWorkoutDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedDuration(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRestDay(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 9:
      var value = new proto.fitness.service.v1.CreateDailyWorkoutExercise;
      reader.readMessage(value,proto.fitness.service.v1.CreateDailyWorkoutExercise.deserializeBinaryFromReader);
      msg.addExercises(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateDailyWorkout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateDailyWorkout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateDailyWorkout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDayNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDayOfWeek();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWorkoutDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEstimatedDuration();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getIsRestDay();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExercisesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.fitness.service.v1.CreateDailyWorkoutExercise.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 day_number = 1;
 * @return {number}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.getDayNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkout} returns this
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.setDayNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string day_of_week = 2;
 * @return {string}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.getDayOfWeek = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkout} returns this
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.setDayOfWeek = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp workout_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.getWorkoutDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkout} returns this
*/
proto.fitness.service.v1.CreateDailyWorkout.prototype.setWorkoutDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.CreateDailyWorkout} returns this
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.clearWorkoutDate = function() {
  return this.setWorkoutDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.hasWorkoutDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkout} returns this
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkout} returns this
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 estimated_duration = 6;
 * @return {number}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.getEstimatedDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkout} returns this
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.setEstimatedDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool is_rest_day = 7;
 * @return {boolean}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.getIsRestDay = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkout} returns this
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.setIsRestDay = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string notes = 8;
 * @return {string}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkout} returns this
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated CreateDailyWorkoutExercise exercises = 9;
 * @return {!Array<!proto.fitness.service.v1.CreateDailyWorkoutExercise>}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.getExercisesList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.CreateDailyWorkoutExercise>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.CreateDailyWorkoutExercise, 9));
};


/**
 * @param {!Array<!proto.fitness.service.v1.CreateDailyWorkoutExercise>} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkout} returns this
*/
proto.fitness.service.v1.CreateDailyWorkout.prototype.setExercisesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.fitness.service.v1.CreateDailyWorkoutExercise=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise}
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.addExercises = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.fitness.service.v1.CreateDailyWorkoutExercise, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.CreateDailyWorkout} returns this
 */
proto.fitness.service.v1.CreateDailyWorkout.prototype.clearExercisesList = function() {
  return this.setExercisesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateDailyWorkoutExercise.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateDailyWorkoutExercise} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.toObject = function(includeInstance, msg) {
  var f, obj = {
exerciseId: jspb.Message.getFieldWithDefault(msg, 1, ""),
orderIndex: jspb.Message.getFieldWithDefault(msg, 2, 0),
sets: jspb.Message.getFieldWithDefault(msg, 3, 0),
reps: jspb.Message.getFieldWithDefault(msg, 4, ""),
weight: jspb.Message.getFieldWithDefault(msg, 5, ""),
restTime: jspb.Message.getFieldWithDefault(msg, 6, ""),
notes: jspb.Message.getFieldWithDefault(msg, 7, ""),
isSuperset: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
supersetGroup: jspb.Message.getFieldWithDefault(msg, 9, 0),
isWarmup: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
isCooldown: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateDailyWorkoutExercise;
  return proto.fitness.service.v1.CreateDailyWorkoutExercise.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateDailyWorkoutExercise} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderIndex(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSets(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReps(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWeight(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRestTime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuperset(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSupersetGroup(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsWarmup(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCooldown(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateDailyWorkoutExercise.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateDailyWorkoutExercise} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderIndex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSets();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getReps();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getWeight();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRestTime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsSuperset();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getSupersetGroup();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getIsWarmup();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getIsCooldown();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional string exercise_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 order_index = 2;
 * @return {number}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.getOrderIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.setOrderIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 sets = 3;
 * @return {number}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.getSets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.setSets = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string reps = 4;
 * @return {string}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.getReps = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.setReps = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string weight = 5;
 * @return {string}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.getWeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.setWeight = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string rest_time = 6;
 * @return {string}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.getRestTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.setRestTime = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string notes = 7;
 * @return {string}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool is_superset = 8;
 * @return {boolean}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.getIsSuperset = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.setIsSuperset = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int32 superset_group = 9;
 * @return {number}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.getSupersetGroup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.setSupersetGroup = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool is_warmup = 10;
 * @return {boolean}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.getIsWarmup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.setIsWarmup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool is_cooldown = 11;
 * @return {boolean}
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.getIsCooldown = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.CreateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.CreateDailyWorkoutExercise.prototype.setIsCooldown = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateWorkoutPlanExercise.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateWorkoutPlanExercise} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.toObject = function(includeInstance, msg) {
  var f, obj = {
exerciseId: jspb.Message.getFieldWithDefault(msg, 1, ""),
orderIndex: jspb.Message.getFieldWithDefault(msg, 2, 0),
sets: jspb.Message.getFieldWithDefault(msg, 3, 0),
reps: jspb.Message.getFieldWithDefault(msg, 4, ""),
weight: jspb.Message.getFieldWithDefault(msg, 5, ""),
restTime: jspb.Message.getFieldWithDefault(msg, 6, ""),
notes: jspb.Message.getFieldWithDefault(msg, 7, ""),
isSuperset: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
supersetGroup: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanExercise}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateWorkoutPlanExercise;
  return proto.fitness.service.v1.CreateWorkoutPlanExercise.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateWorkoutPlanExercise} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanExercise}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderIndex(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSets(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReps(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWeight(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRestTime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuperset(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSupersetGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateWorkoutPlanExercise.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateWorkoutPlanExercise} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderIndex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSets();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getReps();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getWeight();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRestTime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsSuperset();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getSupersetGroup();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string exercise_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 order_index = 2;
 * @return {number}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.getOrderIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.setOrderIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 sets = 3;
 * @return {number}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.getSets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.setSets = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string reps = 4;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.getReps = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.setReps = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string weight = 5;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.getWeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.setWeight = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string rest_time = 6;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.getRestTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.setRestTime = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string notes = 7;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool is_superset = 8;
 * @return {boolean}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.getIsSuperset = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.setIsSuperset = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int32 superset_group = 9;
 * @return {number}
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.getSupersetGroup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanExercise.prototype.setSupersetGroup = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CreateWorkoutPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CreateWorkoutPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
workoutPlan: (f = msg.getWorkoutPlan()) && proto.fitness.service.v1.WorkoutPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanResponse}
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CreateWorkoutPlanResponse;
  return proto.fitness.service.v1.CreateWorkoutPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CreateWorkoutPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanResponse}
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 2:
      var value = new proto.fitness.service.v1.WorkoutPlan;
      reader.readMessage(value,proto.fitness.service.v1.WorkoutPlan.deserializeBinaryFromReader);
      msg.setWorkoutPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CreateWorkoutPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CreateWorkoutPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkoutPlan();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fitness.service.v1.WorkoutPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional WorkoutPlan workout_plan = 2;
 * @return {?proto.fitness.service.v1.WorkoutPlan}
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse.prototype.getWorkoutPlan = function() {
  return /** @type{?proto.fitness.service.v1.WorkoutPlan} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.WorkoutPlan, 2));
};


/**
 * @param {?proto.fitness.service.v1.WorkoutPlan|undefined} value
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanResponse} returns this
*/
proto.fitness.service.v1.CreateWorkoutPlanResponse.prototype.setWorkoutPlan = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.CreateWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse.prototype.clearWorkoutPlan = function() {
  return this.setWorkoutPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.CreateWorkoutPlanResponse.prototype.hasWorkoutPlan = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetWorkoutPlansRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetWorkoutPlansRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
clientId: jspb.Message.getFieldWithDefault(msg, 3, ""),
activeOnly: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
search: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetWorkoutPlansRequest}
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetWorkoutPlansRequest;
  return proto.fitness.service.v1.GetWorkoutPlansRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetWorkoutPlansRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetWorkoutPlansRequest}
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActiveOnly(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetWorkoutPlansRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetWorkoutPlansRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActiveOnly();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutPlansRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutPlansRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string client_id = 3;
 * @return {string}
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetWorkoutPlansRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool active_only = 4;
 * @return {boolean}
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.getActiveOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.GetWorkoutPlansRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.setActiveOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string search = 5;
 * @return {string}
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetWorkoutPlansRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutPlansRequest.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetWorkoutPlansResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetWorkoutPlansResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workoutPlansList: jspb.Message.toObjectList(msg.getWorkoutPlansList(),
    proto.fitness.service.v1.WorkoutPlan.toObject, includeInstance),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetWorkoutPlansResponse}
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetWorkoutPlansResponse;
  return proto.fitness.service.v1.GetWorkoutPlansResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetWorkoutPlansResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetWorkoutPlansResponse}
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.WorkoutPlan;
      reader.readMessage(value,proto.fitness.service.v1.WorkoutPlan.deserializeBinaryFromReader);
      msg.addWorkoutPlans(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetWorkoutPlansResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetWorkoutPlansResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkoutPlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fitness.service.v1.WorkoutPlan.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated WorkoutPlan workout_plans = 1;
 * @return {!Array<!proto.fitness.service.v1.WorkoutPlan>}
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.getWorkoutPlansList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.WorkoutPlan>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.WorkoutPlan, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.WorkoutPlan>} value
 * @return {!proto.fitness.service.v1.GetWorkoutPlansResponse} returns this
*/
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.setWorkoutPlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.WorkoutPlan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.WorkoutPlan}
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.addWorkoutPlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.WorkoutPlan, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetWorkoutPlansResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.clearWorkoutPlansList = function() {
  return this.setWorkoutPlansList([]);
};


/**
 * optional int32 total_count = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutPlansResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutPlansResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutPlansResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutPlansResponse.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetWorkoutPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetWorkoutPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetWorkoutPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workoutPlanId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetWorkoutPlanRequest}
 */
proto.fitness.service.v1.GetWorkoutPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetWorkoutPlanRequest;
  return proto.fitness.service.v1.GetWorkoutPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetWorkoutPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetWorkoutPlanRequest}
 */
proto.fitness.service.v1.GetWorkoutPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkoutPlanId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetWorkoutPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetWorkoutPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetWorkoutPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkoutPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string workout_plan_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetWorkoutPlanRequest.prototype.getWorkoutPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutPlanRequest.prototype.setWorkoutPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetWorkoutPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetWorkoutPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetWorkoutPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
workoutPlan: (f = msg.getWorkoutPlan()) && proto.fitness.service.v1.WorkoutPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetWorkoutPlanResponse}
 */
proto.fitness.service.v1.GetWorkoutPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetWorkoutPlanResponse;
  return proto.fitness.service.v1.GetWorkoutPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetWorkoutPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetWorkoutPlanResponse}
 */
proto.fitness.service.v1.GetWorkoutPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.WorkoutPlan;
      reader.readMessage(value,proto.fitness.service.v1.WorkoutPlan.deserializeBinaryFromReader);
      msg.setWorkoutPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetWorkoutPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetWorkoutPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetWorkoutPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkoutPlan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.WorkoutPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional WorkoutPlan workout_plan = 1;
 * @return {?proto.fitness.service.v1.WorkoutPlan}
 */
proto.fitness.service.v1.GetWorkoutPlanResponse.prototype.getWorkoutPlan = function() {
  return /** @type{?proto.fitness.service.v1.WorkoutPlan} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.WorkoutPlan, 1));
};


/**
 * @param {?proto.fitness.service.v1.WorkoutPlan|undefined} value
 * @return {!proto.fitness.service.v1.GetWorkoutPlanResponse} returns this
*/
proto.fitness.service.v1.GetWorkoutPlanResponse.prototype.setWorkoutPlan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutPlanResponse.prototype.clearWorkoutPlan = function() {
  return this.setWorkoutPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetWorkoutPlanResponse.prototype.hasWorkoutPlan = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateWorkoutPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workoutPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
goals: jspb.Message.getFieldWithDefault(msg, 6, ""),
notes: jspb.Message.getFieldWithDefault(msg, 7, ""),
difficulty: jspb.Message.getFieldWithDefault(msg, 8, ""),
duration: jspb.Message.getFieldWithDefault(msg, 9, 0),
isActive: (f = jspb.Message.getBooleanField(msg, 10)) == null ? undefined : f,
exercisesList: jspb.Message.toObjectList(msg.getExercisesList(),
    proto.fitness.service.v1.UpdateWorkoutPlanExercise.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateWorkoutPlanRequest;
  return proto.fitness.service.v1.UpdateWorkoutPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkoutPlanId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGoals(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDifficulty(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDuration(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 11:
      var value = new proto.fitness.service.v1.UpdateWorkoutPlanExercise;
      reader.readMessage(value,proto.fitness.service.v1.UpdateWorkoutPlanExercise.deserializeBinaryFromReader);
      msg.addExercises(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateWorkoutPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkoutPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getGoals();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDifficulty();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getExercisesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.fitness.service.v1.UpdateWorkoutPlanExercise.serializeBinaryToWriter
    );
  }
};


/**
 * optional string workout_plan_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.getWorkoutPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.setWorkoutPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp start_date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
*/
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
*/
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string goals = 6;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.getGoals = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.setGoals = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string notes = 7;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string difficulty = 8;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.getDifficulty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 duration = 9;
 * @return {number}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.setDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool is_active = 10;
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.setIsActive = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.clearIsActive = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.hasIsActive = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * repeated UpdateWorkoutPlanExercise exercises = 11;
 * @return {!Array<!proto.fitness.service.v1.UpdateWorkoutPlanExercise>}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.getExercisesList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.UpdateWorkoutPlanExercise>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.UpdateWorkoutPlanExercise, 11));
};


/**
 * @param {!Array<!proto.fitness.service.v1.UpdateWorkoutPlanExercise>} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
*/
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.setExercisesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanExercise=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise}
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.addExercises = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.fitness.service.v1.UpdateWorkoutPlanExercise, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanRequest.prototype.clearExercisesList = function() {
  return this.setExercisesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateWorkoutPlanExercise.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
exerciseId: jspb.Message.getFieldWithDefault(msg, 2, ""),
orderIndex: jspb.Message.getFieldWithDefault(msg, 3, 0),
sets: jspb.Message.getFieldWithDefault(msg, 4, 0),
reps: jspb.Message.getFieldWithDefault(msg, 5, ""),
weight: jspb.Message.getFieldWithDefault(msg, 6, ""),
restTime: jspb.Message.getFieldWithDefault(msg, 7, ""),
notes: jspb.Message.getFieldWithDefault(msg, 8, ""),
isSuperset: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
supersetGroup: jspb.Message.getFieldWithDefault(msg, 10, 0),
pb_delete: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateWorkoutPlanExercise;
  return proto.fitness.service.v1.UpdateWorkoutPlanExercise.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderIndex(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSets(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReps(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWeight(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRestTime(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuperset(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSupersetGroup(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDelete(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateWorkoutPlanExercise.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderIndex();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSets();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getReps();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getWeight();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRestTime();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsSuperset();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getSupersetGroup();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getDelete();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string exercise_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 order_index = 3;
 * @return {number}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.getOrderIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.setOrderIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 sets = 4;
 * @return {number}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.getSets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.setSets = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string reps = 5;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.getReps = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.setReps = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string weight = 6;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.getWeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.setWeight = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string rest_time = 7;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.getRestTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.setRestTime = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string notes = 8;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool is_superset = 9;
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.getIsSuperset = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.setIsSuperset = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional int32 superset_group = 10;
 * @return {number}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.getSupersetGroup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.setSupersetGroup = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional bool delete = 11;
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.getDelete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanExercise} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanExercise.prototype.setDelete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateWorkoutPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
workoutPlan: (f = msg.getWorkoutPlan()) && proto.fitness.service.v1.WorkoutPlan.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanResponse}
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateWorkoutPlanResponse;
  return proto.fitness.service.v1.UpdateWorkoutPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanResponse}
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 2:
      var value = new proto.fitness.service.v1.WorkoutPlan;
      reader.readMessage(value,proto.fitness.service.v1.WorkoutPlan.deserializeBinaryFromReader);
      msg.setWorkoutPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateWorkoutPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkoutPlan();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fitness.service.v1.WorkoutPlan.serializeBinaryToWriter
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional WorkoutPlan workout_plan = 2;
 * @return {?proto.fitness.service.v1.WorkoutPlan}
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse.prototype.getWorkoutPlan = function() {
  return /** @type{?proto.fitness.service.v1.WorkoutPlan} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.WorkoutPlan, 2));
};


/**
 * @param {?proto.fitness.service.v1.WorkoutPlan|undefined} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanResponse} returns this
*/
proto.fitness.service.v1.UpdateWorkoutPlanResponse.prototype.setWorkoutPlan = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.UpdateWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse.prototype.clearWorkoutPlan = function() {
  return this.setWorkoutPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateWorkoutPlanResponse.prototype.hasWorkoutPlan = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DeleteWorkoutPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DeleteWorkoutPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DeleteWorkoutPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteWorkoutPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workoutPlanId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DeleteWorkoutPlanRequest}
 */
proto.fitness.service.v1.DeleteWorkoutPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DeleteWorkoutPlanRequest;
  return proto.fitness.service.v1.DeleteWorkoutPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DeleteWorkoutPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DeleteWorkoutPlanRequest}
 */
proto.fitness.service.v1.DeleteWorkoutPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkoutPlanId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DeleteWorkoutPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DeleteWorkoutPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DeleteWorkoutPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteWorkoutPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkoutPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string workout_plan_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.DeleteWorkoutPlanRequest.prototype.getWorkoutPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeleteWorkoutPlanRequest} returns this
 */
proto.fitness.service.v1.DeleteWorkoutPlanRequest.prototype.setWorkoutPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DeleteWorkoutPlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DeleteWorkoutPlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DeleteWorkoutPlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteWorkoutPlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DeleteWorkoutPlanResponse}
 */
proto.fitness.service.v1.DeleteWorkoutPlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DeleteWorkoutPlanResponse;
  return proto.fitness.service.v1.DeleteWorkoutPlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DeleteWorkoutPlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DeleteWorkoutPlanResponse}
 */
proto.fitness.service.v1.DeleteWorkoutPlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DeleteWorkoutPlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DeleteWorkoutPlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DeleteWorkoutPlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteWorkoutPlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.DeleteWorkoutPlanResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeleteWorkoutPlanResponse} returns this
 */
proto.fitness.service.v1.DeleteWorkoutPlanResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetDailyWorkoutsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetDailyWorkoutsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workoutPlanId: jspb.Message.getFieldWithDefault(msg, 1, ""),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsRequest}
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetDailyWorkoutsRequest;
  return proto.fitness.service.v1.GetDailyWorkoutsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetDailyWorkoutsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsRequest}
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkoutPlanId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetDailyWorkoutsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetDailyWorkoutsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkoutPlanId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string workout_plan_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.prototype.getWorkoutPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsRequest} returns this
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.prototype.setWorkoutPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsRequest} returns this
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsRequest} returns this
 */
proto.fitness.service.v1.GetDailyWorkoutsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetDailyWorkoutsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetDailyWorkoutsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dailyWorkoutsList: jspb.Message.toObjectList(msg.getDailyWorkoutsList(),
    proto.fitness.service.v1.DailyWorkout.toObject, includeInstance),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0),
message: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsResponse}
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetDailyWorkoutsResponse;
  return proto.fitness.service.v1.GetDailyWorkoutsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetDailyWorkoutsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsResponse}
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.DailyWorkout;
      reader.readMessage(value,proto.fitness.service.v1.DailyWorkout.deserializeBinaryFromReader);
      msg.addDailyWorkouts(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetDailyWorkoutsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetDailyWorkoutsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyWorkoutsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fitness.service.v1.DailyWorkout.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * repeated DailyWorkout daily_workouts = 1;
 * @return {!Array<!proto.fitness.service.v1.DailyWorkout>}
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.getDailyWorkoutsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.DailyWorkout>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.DailyWorkout, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.DailyWorkout>} value
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsResponse} returns this
*/
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.setDailyWorkoutsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.DailyWorkout=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.DailyWorkout}
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.addDailyWorkouts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.DailyWorkout, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsResponse} returns this
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.clearDailyWorkoutsList = function() {
  return this.setDailyWorkoutsList([]);
};


/**
 * optional int32 total_count = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsResponse} returns this
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsResponse} returns this
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsResponse} returns this
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string message = 5;
 * @return {string}
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetDailyWorkoutsResponse} returns this
 */
proto.fitness.service.v1.GetDailyWorkoutsResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetDailyWorkoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetDailyWorkoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetDailyWorkoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetDailyWorkoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
dailyWorkoutId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetDailyWorkoutRequest}
 */
proto.fitness.service.v1.GetDailyWorkoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetDailyWorkoutRequest;
  return proto.fitness.service.v1.GetDailyWorkoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetDailyWorkoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetDailyWorkoutRequest}
 */
proto.fitness.service.v1.GetDailyWorkoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDailyWorkoutId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetDailyWorkoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetDailyWorkoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetDailyWorkoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetDailyWorkoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyWorkoutId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string daily_workout_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetDailyWorkoutRequest.prototype.getDailyWorkoutId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetDailyWorkoutRequest} returns this
 */
proto.fitness.service.v1.GetDailyWorkoutRequest.prototype.setDailyWorkoutId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetDailyWorkoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetDailyWorkoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetDailyWorkoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetDailyWorkoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dailyWorkout: (f = msg.getDailyWorkout()) && proto.fitness.service.v1.DailyWorkout.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetDailyWorkoutResponse}
 */
proto.fitness.service.v1.GetDailyWorkoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetDailyWorkoutResponse;
  return proto.fitness.service.v1.GetDailyWorkoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetDailyWorkoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetDailyWorkoutResponse}
 */
proto.fitness.service.v1.GetDailyWorkoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.DailyWorkout;
      reader.readMessage(value,proto.fitness.service.v1.DailyWorkout.deserializeBinaryFromReader);
      msg.setDailyWorkout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetDailyWorkoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetDailyWorkoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetDailyWorkoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetDailyWorkoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyWorkout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.DailyWorkout.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional DailyWorkout daily_workout = 1;
 * @return {?proto.fitness.service.v1.DailyWorkout}
 */
proto.fitness.service.v1.GetDailyWorkoutResponse.prototype.getDailyWorkout = function() {
  return /** @type{?proto.fitness.service.v1.DailyWorkout} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.DailyWorkout, 1));
};


/**
 * @param {?proto.fitness.service.v1.DailyWorkout|undefined} value
 * @return {!proto.fitness.service.v1.GetDailyWorkoutResponse} returns this
*/
proto.fitness.service.v1.GetDailyWorkoutResponse.prototype.setDailyWorkout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetDailyWorkoutResponse} returns this
 */
proto.fitness.service.v1.GetDailyWorkoutResponse.prototype.clearDailyWorkout = function() {
  return this.setDailyWorkout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetDailyWorkoutResponse.prototype.hasDailyWorkout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.GetDailyWorkoutResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetDailyWorkoutResponse} returns this
 */
proto.fitness.service.v1.GetDailyWorkoutResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateDailyWorkoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
dailyWorkoutId: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
estimatedDuration: jspb.Message.getFieldWithDefault(msg, 4, 0),
isRestDay: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
notes: jspb.Message.getFieldWithDefault(msg, 6, ""),
exercisesList: jspb.Message.toObjectList(msg.getExercisesList(),
    proto.fitness.service.v1.UpdateDailyWorkoutExercise.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutRequest}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateDailyWorkoutRequest;
  return proto.fitness.service.v1.UpdateDailyWorkoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutRequest}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDailyWorkoutId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedDuration(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRestDay(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 7:
      var value = new proto.fitness.service.v1.UpdateDailyWorkoutExercise;
      reader.readMessage(value,proto.fitness.service.v1.UpdateDailyWorkoutExercise.deserializeBinaryFromReader);
      msg.addExercises(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateDailyWorkoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyWorkoutId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEstimatedDuration();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIsRestDay();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getExercisesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.fitness.service.v1.UpdateDailyWorkoutExercise.serializeBinaryToWriter
    );
  }
};


/**
 * optional string daily_workout_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.getDailyWorkoutId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.setDailyWorkoutId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 estimated_duration = 4;
 * @return {number}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.getEstimatedDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.setEstimatedDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool is_rest_day = 5;
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.getIsRestDay = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.setIsRestDay = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated UpdateDailyWorkoutExercise exercises = 7;
 * @return {!Array<!proto.fitness.service.v1.UpdateDailyWorkoutExercise>}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.getExercisesList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.UpdateDailyWorkoutExercise>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.UpdateDailyWorkoutExercise, 7));
};


/**
 * @param {!Array<!proto.fitness.service.v1.UpdateDailyWorkoutExercise>} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} returns this
*/
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.setExercisesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutExercise=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise}
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.addExercises = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.fitness.service.v1.UpdateDailyWorkoutExercise, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutRequest.prototype.clearExercisesList = function() {
  return this.setExercisesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateDailyWorkoutExercise.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
exerciseId: jspb.Message.getFieldWithDefault(msg, 2, ""),
orderIndex: jspb.Message.getFieldWithDefault(msg, 3, 0),
sets: jspb.Message.getFieldWithDefault(msg, 4, 0),
reps: jspb.Message.getFieldWithDefault(msg, 5, ""),
weight: jspb.Message.getFieldWithDefault(msg, 6, ""),
restTime: jspb.Message.getFieldWithDefault(msg, 7, ""),
notes: jspb.Message.getFieldWithDefault(msg, 8, ""),
isSuperset: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
supersetGroup: jspb.Message.getFieldWithDefault(msg, 10, 0),
isWarmup: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
isCooldown: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
isDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateDailyWorkoutExercise;
  return proto.fitness.service.v1.UpdateDailyWorkoutExercise.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderIndex(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSets(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReps(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWeight(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRestTime(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSuperset(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSupersetGroup(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsWarmup(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCooldown(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateDailyWorkoutExercise.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderIndex();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSets();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getReps();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getWeight();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRestTime();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsSuperset();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getSupersetGroup();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getIsWarmup();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getIsCooldown();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIsDeleted();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string exercise_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 order_index = 3;
 * @return {number}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getOrderIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setOrderIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 sets = 4;
 * @return {number}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getSets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setSets = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string reps = 5;
 * @return {string}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getReps = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setReps = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string weight = 6;
 * @return {string}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getWeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setWeight = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string rest_time = 7;
 * @return {string}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getRestTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setRestTime = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string notes = 8;
 * @return {string}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool is_superset = 9;
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getIsSuperset = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setIsSuperset = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional int32 superset_group = 10;
 * @return {number}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getSupersetGroup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setSupersetGroup = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional bool is_warmup = 11;
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getIsWarmup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setIsWarmup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool is_cooldown = 12;
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getIsCooldown = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setIsCooldown = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool is_deleted = 13;
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.getIsDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutExercise} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutExercise.prototype.setIsDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateDailyWorkoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dailyWorkout: (f = msg.getDailyWorkout()) && proto.fitness.service.v1.DailyWorkout.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutResponse}
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateDailyWorkoutResponse;
  return proto.fitness.service.v1.UpdateDailyWorkoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutResponse}
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.DailyWorkout;
      reader.readMessage(value,proto.fitness.service.v1.DailyWorkout.deserializeBinaryFromReader);
      msg.setDailyWorkout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateDailyWorkoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyWorkout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.DailyWorkout.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional DailyWorkout daily_workout = 1;
 * @return {?proto.fitness.service.v1.DailyWorkout}
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse.prototype.getDailyWorkout = function() {
  return /** @type{?proto.fitness.service.v1.DailyWorkout} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.DailyWorkout, 1));
};


/**
 * @param {?proto.fitness.service.v1.DailyWorkout|undefined} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutResponse} returns this
*/
proto.fitness.service.v1.UpdateDailyWorkoutResponse.prototype.setDailyWorkout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutResponse} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse.prototype.clearDailyWorkout = function() {
  return this.setDailyWorkout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse.prototype.hasDailyWorkout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateDailyWorkoutResponse} returns this
 */
proto.fitness.service.v1.UpdateDailyWorkoutResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DeleteDailyWorkoutRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DeleteDailyWorkoutRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DeleteDailyWorkoutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteDailyWorkoutRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
dailyWorkoutId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DeleteDailyWorkoutRequest}
 */
proto.fitness.service.v1.DeleteDailyWorkoutRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DeleteDailyWorkoutRequest;
  return proto.fitness.service.v1.DeleteDailyWorkoutRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DeleteDailyWorkoutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DeleteDailyWorkoutRequest}
 */
proto.fitness.service.v1.DeleteDailyWorkoutRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDailyWorkoutId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DeleteDailyWorkoutRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DeleteDailyWorkoutRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DeleteDailyWorkoutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteDailyWorkoutRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyWorkoutId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string daily_workout_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.DeleteDailyWorkoutRequest.prototype.getDailyWorkoutId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeleteDailyWorkoutRequest} returns this
 */
proto.fitness.service.v1.DeleteDailyWorkoutRequest.prototype.setDailyWorkoutId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DeleteDailyWorkoutResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DeleteDailyWorkoutResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DeleteDailyWorkoutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteDailyWorkoutResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
planDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DeleteDailyWorkoutResponse}
 */
proto.fitness.service.v1.DeleteDailyWorkoutResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DeleteDailyWorkoutResponse;
  return proto.fitness.service.v1.DeleteDailyWorkoutResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DeleteDailyWorkoutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DeleteDailyWorkoutResponse}
 */
proto.fitness.service.v1.DeleteDailyWorkoutResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlanDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DeleteDailyWorkoutResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DeleteDailyWorkoutResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DeleteDailyWorkoutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DeleteDailyWorkoutResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlanDeleted();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.fitness.service.v1.DeleteDailyWorkoutResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DeleteDailyWorkoutResponse} returns this
 */
proto.fitness.service.v1.DeleteDailyWorkoutResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool plan_deleted = 2;
 * @return {boolean}
 */
proto.fitness.service.v1.DeleteDailyWorkoutResponse.prototype.getPlanDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.DeleteDailyWorkoutResponse} returns this
 */
proto.fitness.service.v1.DeleteDailyWorkoutResponse.prototype.setPlanDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetWorkoutStatsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetWorkoutStatsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
trainerId: jspb.Message.getFieldWithDefault(msg, 1, ""),
startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetWorkoutStatsRequest}
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetWorkoutStatsRequest;
  return proto.fitness.service.v1.GetWorkoutStatsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetWorkoutStatsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetWorkoutStatsRequest}
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTrainerId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetWorkoutStatsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetWorkoutStatsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrainerId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string trainer_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.getTrainerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetWorkoutStatsRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.setTrainerId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp start_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.GetWorkoutStatsRequest} returns this
*/
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetWorkoutStatsRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.GetWorkoutStatsRequest} returns this
*/
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetWorkoutStatsRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetWorkoutStatsRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetWorkoutStatsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetWorkoutStatsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
totalPlansCreated: jspb.Message.getFieldWithDefault(msg, 1, 0),
activePlans: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalClients: jspb.Message.getFieldWithDefault(msg, 3, 0),
clientStatsList: jspb.Message.toObjectList(msg.getClientStatsList(),
    proto.fitness.service.v1.ClientStats.toObject, includeInstance),
planTypeStatsList: jspb.Message.toObjectList(msg.getPlanTypeStatsList(),
    proto.fitness.service.v1.PlanTypeStats.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetWorkoutStatsResponse}
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetWorkoutStatsResponse;
  return proto.fitness.service.v1.GetWorkoutStatsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetWorkoutStatsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetWorkoutStatsResponse}
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPlansCreated(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActivePlans(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalClients(value);
      break;
    case 4:
      var value = new proto.fitness.service.v1.ClientStats;
      reader.readMessage(value,proto.fitness.service.v1.ClientStats.deserializeBinaryFromReader);
      msg.addClientStats(value);
      break;
    case 5:
      var value = new proto.fitness.service.v1.PlanTypeStats;
      reader.readMessage(value,proto.fitness.service.v1.PlanTypeStats.deserializeBinaryFromReader);
      msg.addPlanTypeStats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetWorkoutStatsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetWorkoutStatsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalPlansCreated();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getActivePlans();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalClients();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getClientStatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.fitness.service.v1.ClientStats.serializeBinaryToWriter
    );
  }
  f = message.getPlanTypeStatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.fitness.service.v1.PlanTypeStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 total_plans_created = 1;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.getTotalPlansCreated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutStatsResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.setTotalPlansCreated = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 active_plans = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.getActivePlans = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutStatsResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.setActivePlans = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 total_clients = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.getTotalClients = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutStatsResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.setTotalClients = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ClientStats client_stats = 4;
 * @return {!Array<!proto.fitness.service.v1.ClientStats>}
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.getClientStatsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.ClientStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.ClientStats, 4));
};


/**
 * @param {!Array<!proto.fitness.service.v1.ClientStats>} value
 * @return {!proto.fitness.service.v1.GetWorkoutStatsResponse} returns this
*/
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.setClientStatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.fitness.service.v1.ClientStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.ClientStats}
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.addClientStats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.fitness.service.v1.ClientStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetWorkoutStatsResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.clearClientStatsList = function() {
  return this.setClientStatsList([]);
};


/**
 * repeated PlanTypeStats plan_type_stats = 5;
 * @return {!Array<!proto.fitness.service.v1.PlanTypeStats>}
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.getPlanTypeStatsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.PlanTypeStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.PlanTypeStats, 5));
};


/**
 * @param {!Array<!proto.fitness.service.v1.PlanTypeStats>} value
 * @return {!proto.fitness.service.v1.GetWorkoutStatsResponse} returns this
*/
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.setPlanTypeStatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.fitness.service.v1.PlanTypeStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.PlanTypeStats}
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.addPlanTypeStats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.fitness.service.v1.PlanTypeStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetWorkoutStatsResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutStatsResponse.prototype.clearPlanTypeStatsList = function() {
  return this.setPlanTypeStatsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.ClientStats.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.ClientStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.ClientStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ClientStats.toObject = function(includeInstance, msg) {
  var f, obj = {
clientId: jspb.Message.getFieldWithDefault(msg, 1, ""),
clientName: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalPlans: jspb.Message.getFieldWithDefault(msg, 3, 0),
activePlans: jspb.Message.getFieldWithDefault(msg, 4, 0),
lastPlanCreated: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.ClientStats}
 */
proto.fitness.service.v1.ClientStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.ClientStats;
  return proto.fitness.service.v1.ClientStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.ClientStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.ClientStats}
 */
proto.fitness.service.v1.ClientStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPlans(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActivePlans(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLastPlanCreated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.ClientStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.ClientStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.ClientStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ClientStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalPlans();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getActivePlans();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getLastPlanCreated();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string client_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.ClientStats.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ClientStats} returns this
 */
proto.fitness.service.v1.ClientStats.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_name = 2;
 * @return {string}
 */
proto.fitness.service.v1.ClientStats.prototype.getClientName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ClientStats} returns this
 */
proto.fitness.service.v1.ClientStats.prototype.setClientName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 total_plans = 3;
 * @return {number}
 */
proto.fitness.service.v1.ClientStats.prototype.getTotalPlans = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ClientStats} returns this
 */
proto.fitness.service.v1.ClientStats.prototype.setTotalPlans = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 active_plans = 4;
 * @return {number}
 */
proto.fitness.service.v1.ClientStats.prototype.getActivePlans = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ClientStats} returns this
 */
proto.fitness.service.v1.ClientStats.prototype.setActivePlans = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string last_plan_created = 5;
 * @return {string}
 */
proto.fitness.service.v1.ClientStats.prototype.getLastPlanCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ClientStats} returns this
 */
proto.fitness.service.v1.ClientStats.prototype.setLastPlanCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.PlanTypeStats.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.PlanTypeStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.PlanTypeStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.PlanTypeStats.toObject = function(includeInstance, msg) {
  var f, obj = {
planType: jspb.Message.getFieldWithDefault(msg, 1, ""),
count: jspb.Message.getFieldWithDefault(msg, 2, 0),
percentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.PlanTypeStats}
 */
proto.fitness.service.v1.PlanTypeStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.PlanTypeStats;
  return proto.fitness.service.v1.PlanTypeStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.PlanTypeStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.PlanTypeStats}
 */
proto.fitness.service.v1.PlanTypeStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPlanType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.PlanTypeStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.PlanTypeStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.PlanTypeStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.PlanTypeStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlanType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional string plan_type = 1;
 * @return {string}
 */
proto.fitness.service.v1.PlanTypeStats.prototype.getPlanType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.PlanTypeStats} returns this
 */
proto.fitness.service.v1.PlanTypeStats.prototype.setPlanType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 count = 2;
 * @return {number}
 */
proto.fitness.service.v1.PlanTypeStats.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.PlanTypeStats} returns this
 */
proto.fitness.service.v1.PlanTypeStats.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double percentage = 3;
 * @return {number}
 */
proto.fitness.service.v1.PlanTypeStats.prototype.getPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.PlanTypeStats} returns this
 */
proto.fitness.service.v1.PlanTypeStats.prototype.setPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.WorkoutSet.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.WorkoutSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.WorkoutSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.WorkoutSet.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
dailyWorkoutExerciseId: jspb.Message.getFieldWithDefault(msg, 2, ""),
exerciseId: jspb.Message.getFieldWithDefault(msg, 3, ""),
exerciseName: jspb.Message.getFieldWithDefault(msg, 4, ""),
setNumber: jspb.Message.getFieldWithDefault(msg, 5, 0),
reps: jspb.Message.getFieldWithDefault(msg, 6, 0),
weightKg: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
completed: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
notes: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.WorkoutSet}
 */
proto.fitness.service.v1.WorkoutSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.WorkoutSet;
  return proto.fitness.service.v1.WorkoutSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.WorkoutSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.WorkoutSet}
 */
proto.fitness.service.v1.WorkoutSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDailyWorkoutExerciseId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSetNumber(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReps(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWeightKg(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleted(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.WorkoutSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.WorkoutSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.WorkoutSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.WorkoutSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDailyWorkoutExerciseId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExerciseName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSetNumber();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getReps();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getWeightKg();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getCompleted();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSet.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSet} returns this
 */
proto.fitness.service.v1.WorkoutSet.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string daily_workout_exercise_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSet.prototype.getDailyWorkoutExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSet} returns this
 */
proto.fitness.service.v1.WorkoutSet.prototype.setDailyWorkoutExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string exercise_id = 3;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSet.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSet} returns this
 */
proto.fitness.service.v1.WorkoutSet.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string exercise_name = 4;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSet.prototype.getExerciseName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSet} returns this
 */
proto.fitness.service.v1.WorkoutSet.prototype.setExerciseName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 set_number = 5;
 * @return {number}
 */
proto.fitness.service.v1.WorkoutSet.prototype.getSetNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.WorkoutSet} returns this
 */
proto.fitness.service.v1.WorkoutSet.prototype.setSetNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 reps = 6;
 * @return {number}
 */
proto.fitness.service.v1.WorkoutSet.prototype.getReps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.WorkoutSet} returns this
 */
proto.fitness.service.v1.WorkoutSet.prototype.setReps = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double weight_kg = 7;
 * @return {number}
 */
proto.fitness.service.v1.WorkoutSet.prototype.getWeightKg = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.WorkoutSet} returns this
 */
proto.fitness.service.v1.WorkoutSet.prototype.setWeightKg = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional bool completed = 8;
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutSet.prototype.getCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.WorkoutSet} returns this
 */
proto.fitness.service.v1.WorkoutSet.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string notes = 9;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSet.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSet} returns this
 */
proto.fitness.service.v1.WorkoutSet.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.WorkoutSession.repeatedFields_ = [18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.WorkoutSession.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.WorkoutSession.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.WorkoutSession} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.WorkoutSession.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
clientId: jspb.Message.getFieldWithDefault(msg, 2, ""),
clientName: jspb.Message.getFieldWithDefault(msg, 3, ""),
trainerId: jspb.Message.getFieldWithDefault(msg, 4, ""),
workoutPlanId: jspb.Message.getFieldWithDefault(msg, 5, ""),
dailyWorkoutId: jspb.Message.getFieldWithDefault(msg, 6, ""),
groupId: jspb.Message.getFieldWithDefault(msg, 7, ""),
title: jspb.Message.getFieldWithDefault(msg, 8, ""),
status: jspb.Message.getFieldWithDefault(msg, 9, ""),
startedAt: (f = msg.getStartedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
completedAt: (f = msg.getCompletedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
durationSeconds: jspb.Message.getFieldWithDefault(msg, 12, 0),
rpe: jspb.Message.getFieldWithDefault(msg, 13, 0),
notes: jspb.Message.getFieldWithDefault(msg, 14, ""),
totalVolumeKg: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
completedSets: jspb.Message.getFieldWithDefault(msg, 16, 0),
totalSets: jspb.Message.getFieldWithDefault(msg, 17, 0),
setsList: jspb.Message.toObjectList(msg.getSetsList(),
    proto.fitness.service.v1.WorkoutSet.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.WorkoutSession}
 */
proto.fitness.service.v1.WorkoutSession.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.WorkoutSession;
  return proto.fitness.service.v1.WorkoutSession.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.WorkoutSession} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.WorkoutSession}
 */
proto.fitness.service.v1.WorkoutSession.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTrainerId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setWorkoutPlanId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDailyWorkoutId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTitle(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStatus(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartedAt(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCompletedAt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDurationSeconds(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRpe(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalVolumeKg(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompletedSets(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalSets(value);
      break;
    case 18:
      var value = new proto.fitness.service.v1.WorkoutSet;
      reader.readMessage(value,proto.fitness.service.v1.WorkoutSet.deserializeBinaryFromReader);
      msg.addSets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.WorkoutSession.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.WorkoutSession.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.WorkoutSession} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.WorkoutSession.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTrainerId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getWorkoutPlanId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDailyWorkoutId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getStartedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCompletedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDurationSeconds();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getRpe();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTotalVolumeKg();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getCompletedSets();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getTotalSets();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getSetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.fitness.service.v1.WorkoutSet.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string client_name = 3;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getClientName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setClientName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string trainer_id = 4;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getTrainerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setTrainerId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string workout_plan_id = 5;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getWorkoutPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setWorkoutPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string daily_workout_id = 6;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getDailyWorkoutId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setDailyWorkoutId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string group_id = 7;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string title = 8;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string status = 9;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp started_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getStartedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
*/
proto.fitness.service.v1.WorkoutSession.prototype.setStartedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.clearStartedAt = function() {
  return this.setStartedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutSession.prototype.hasStartedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp completed_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getCompletedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
*/
proto.fitness.service.v1.WorkoutSession.prototype.setCompletedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.clearCompletedAt = function() {
  return this.setCompletedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.WorkoutSession.prototype.hasCompletedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional int32 duration_seconds = 12;
 * @return {number}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setDurationSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 rpe = 13;
 * @return {number}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getRpe = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setRpe = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string notes = 14;
 * @return {string}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional double total_volume_kg = 15;
 * @return {number}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getTotalVolumeKg = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setTotalVolumeKg = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional int32 completed_sets = 16;
 * @return {number}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getCompletedSets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setCompletedSets = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 total_sets = 17;
 * @return {number}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getTotalSets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.setTotalSets = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * repeated WorkoutSet sets = 18;
 * @return {!Array<!proto.fitness.service.v1.WorkoutSet>}
 */
proto.fitness.service.v1.WorkoutSession.prototype.getSetsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.WorkoutSet>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.WorkoutSet, 18));
};


/**
 * @param {!Array<!proto.fitness.service.v1.WorkoutSet>} value
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
*/
proto.fitness.service.v1.WorkoutSession.prototype.setSetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.fitness.service.v1.WorkoutSet=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.WorkoutSet}
 */
proto.fitness.service.v1.WorkoutSession.prototype.addSets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.fitness.service.v1.WorkoutSet, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.WorkoutSession} returns this
 */
proto.fitness.service.v1.WorkoutSession.prototype.clearSetsList = function() {
  return this.setSetsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.StartWorkoutSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.StartWorkoutSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.StartWorkoutSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.StartWorkoutSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
dailyWorkoutId: jspb.Message.getFieldWithDefault(msg, 1, ""),
clientId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.StartWorkoutSessionRequest}
 */
proto.fitness.service.v1.StartWorkoutSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.StartWorkoutSessionRequest;
  return proto.fitness.service.v1.StartWorkoutSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.StartWorkoutSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.StartWorkoutSessionRequest}
 */
proto.fitness.service.v1.StartWorkoutSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDailyWorkoutId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.StartWorkoutSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.StartWorkoutSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.StartWorkoutSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.StartWorkoutSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyWorkoutId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string daily_workout_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.StartWorkoutSessionRequest.prototype.getDailyWorkoutId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.StartWorkoutSessionRequest} returns this
 */
proto.fitness.service.v1.StartWorkoutSessionRequest.prototype.setDailyWorkoutId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.StartWorkoutSessionRequest.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.StartWorkoutSessionRequest} returns this
 */
proto.fitness.service.v1.StartWorkoutSessionRequest.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.StartWorkoutSessionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.StartWorkoutSessionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
session: (f = msg.getSession()) && proto.fitness.service.v1.WorkoutSession.toObject(includeInstance, f),
resumed: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.StartWorkoutSessionResponse}
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.StartWorkoutSessionResponse;
  return proto.fitness.service.v1.StartWorkoutSessionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.StartWorkoutSessionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.StartWorkoutSessionResponse}
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.WorkoutSession;
      reader.readMessage(value,proto.fitness.service.v1.WorkoutSession.deserializeBinaryFromReader);
      msg.setSession(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResumed(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.StartWorkoutSessionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.StartWorkoutSessionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSession();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.WorkoutSession.serializeBinaryToWriter
    );
  }
  f = message.getResumed();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional WorkoutSession session = 1;
 * @return {?proto.fitness.service.v1.WorkoutSession}
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.prototype.getSession = function() {
  return /** @type{?proto.fitness.service.v1.WorkoutSession} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.WorkoutSession, 1));
};


/**
 * @param {?proto.fitness.service.v1.WorkoutSession|undefined} value
 * @return {!proto.fitness.service.v1.StartWorkoutSessionResponse} returns this
*/
proto.fitness.service.v1.StartWorkoutSessionResponse.prototype.setSession = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.StartWorkoutSessionResponse} returns this
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.prototype.clearSession = function() {
  return this.setSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.prototype.hasSession = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool resumed = 2;
 * @return {boolean}
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.prototype.getResumed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.StartWorkoutSessionResponse} returns this
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.prototype.setResumed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.StartWorkoutSessionResponse} returns this
 */
proto.fitness.service.v1.StartWorkoutSessionResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.LogSet.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.LogSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.LogSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.LogSet.toObject = function(includeInstance, msg) {
  var f, obj = {
dailyWorkoutExerciseId: jspb.Message.getFieldWithDefault(msg, 1, ""),
exerciseId: jspb.Message.getFieldWithDefault(msg, 2, ""),
setNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
reps: jspb.Message.getFieldWithDefault(msg, 4, 0),
weightKg: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
completed: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
notes: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.LogSet}
 */
proto.fitness.service.v1.LogSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.LogSet;
  return proto.fitness.service.v1.LogSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.LogSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.LogSet}
 */
proto.fitness.service.v1.LogSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDailyWorkoutExerciseId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSetNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReps(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWeightKg(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleted(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.LogSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.LogSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.LogSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.LogSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyWorkoutExerciseId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSetNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getReps();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getWeightKg();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getCompleted();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string daily_workout_exercise_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.LogSet.prototype.getDailyWorkoutExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.LogSet} returns this
 */
proto.fitness.service.v1.LogSet.prototype.setDailyWorkoutExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string exercise_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.LogSet.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.LogSet} returns this
 */
proto.fitness.service.v1.LogSet.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 set_number = 3;
 * @return {number}
 */
proto.fitness.service.v1.LogSet.prototype.getSetNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.LogSet} returns this
 */
proto.fitness.service.v1.LogSet.prototype.setSetNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 reps = 4;
 * @return {number}
 */
proto.fitness.service.v1.LogSet.prototype.getReps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.LogSet} returns this
 */
proto.fitness.service.v1.LogSet.prototype.setReps = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double weight_kg = 5;
 * @return {number}
 */
proto.fitness.service.v1.LogSet.prototype.getWeightKg = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.LogSet} returns this
 */
proto.fitness.service.v1.LogSet.prototype.setWeightKg = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional bool completed = 6;
 * @return {boolean}
 */
proto.fitness.service.v1.LogSet.prototype.getCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.LogSet} returns this
 */
proto.fitness.service.v1.LogSet.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string notes = 7;
 * @return {string}
 */
proto.fitness.service.v1.LogSet.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.LogSet} returns this
 */
proto.fitness.service.v1.LogSet.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateWorkoutSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateWorkoutSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
setsList: jspb.Message.toObjectList(msg.getSetsList(),
    proto.fitness.service.v1.LogSet.toObject, includeInstance),
notes: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateWorkoutSessionRequest}
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateWorkoutSessionRequest;
  return proto.fitness.service.v1.UpdateWorkoutSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateWorkoutSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateWorkoutSessionRequest}
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionId(value);
      break;
    case 2:
      var value = new proto.fitness.service.v1.LogSet;
      reader.readMessage(value,proto.fitness.service.v1.LogSet.deserializeBinaryFromReader);
      msg.addSets(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateWorkoutSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateWorkoutSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.fitness.service.v1.LogSet.serializeBinaryToWriter
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutSessionRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated LogSet sets = 2;
 * @return {!Array<!proto.fitness.service.v1.LogSet>}
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.prototype.getSetsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.LogSet>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.LogSet, 2));
};


/**
 * @param {!Array<!proto.fitness.service.v1.LogSet>} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutSessionRequest} returns this
*/
proto.fitness.service.v1.UpdateWorkoutSessionRequest.prototype.setSetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.fitness.service.v1.LogSet=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.LogSet}
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.prototype.addSets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fitness.service.v1.LogSet, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.UpdateWorkoutSessionRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.prototype.clearSetsList = function() {
  return this.setSetsList([]);
};


/**
 * optional string notes = 3;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutSessionRequest} returns this
 */
proto.fitness.service.v1.UpdateWorkoutSessionRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.UpdateWorkoutSessionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.UpdateWorkoutSessionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
session: (f = msg.getSession()) && proto.fitness.service.v1.WorkoutSession.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.UpdateWorkoutSessionResponse}
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.UpdateWorkoutSessionResponse;
  return proto.fitness.service.v1.UpdateWorkoutSessionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.UpdateWorkoutSessionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.UpdateWorkoutSessionResponse}
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.WorkoutSession;
      reader.readMessage(value,proto.fitness.service.v1.WorkoutSession.deserializeBinaryFromReader);
      msg.setSession(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.UpdateWorkoutSessionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.UpdateWorkoutSessionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSession();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.WorkoutSession.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional WorkoutSession session = 1;
 * @return {?proto.fitness.service.v1.WorkoutSession}
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse.prototype.getSession = function() {
  return /** @type{?proto.fitness.service.v1.WorkoutSession} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.WorkoutSession, 1));
};


/**
 * @param {?proto.fitness.service.v1.WorkoutSession|undefined} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutSessionResponse} returns this
*/
proto.fitness.service.v1.UpdateWorkoutSessionResponse.prototype.setSession = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.UpdateWorkoutSessionResponse} returns this
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse.prototype.clearSession = function() {
  return this.setSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse.prototype.hasSession = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.UpdateWorkoutSessionResponse} returns this
 */
proto.fitness.service.v1.UpdateWorkoutSessionResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CompleteWorkoutSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CompleteWorkoutSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
durationSeconds: jspb.Message.getFieldWithDefault(msg, 2, 0),
rpe: jspb.Message.getFieldWithDefault(msg, 3, 0),
notes: jspb.Message.getFieldWithDefault(msg, 4, ""),
abandoned: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionRequest}
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CompleteWorkoutSessionRequest;
  return proto.fitness.service.v1.CompleteWorkoutSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CompleteWorkoutSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionRequest}
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDurationSeconds(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRpe(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNotes(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAbandoned(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CompleteWorkoutSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CompleteWorkoutSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDurationSeconds();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRpe();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAbandoned();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionRequest} returns this
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 duration_seconds = 2;
 * @return {number}
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.getDurationSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionRequest} returns this
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.setDurationSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 rpe = 3;
 * @return {number}
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.getRpe = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionRequest} returns this
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.setRpe = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string notes = 4;
 * @return {string}
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionRequest} returns this
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool abandoned = 5;
 * @return {boolean}
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.getAbandoned = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionRequest} returns this
 */
proto.fitness.service.v1.CompleteWorkoutSessionRequest.prototype.setAbandoned = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.CompleteWorkoutSessionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.CompleteWorkoutSessionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
session: (f = msg.getSession()) && proto.fitness.service.v1.WorkoutSession.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionResponse}
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.CompleteWorkoutSessionResponse;
  return proto.fitness.service.v1.CompleteWorkoutSessionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.CompleteWorkoutSessionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionResponse}
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.WorkoutSession;
      reader.readMessage(value,proto.fitness.service.v1.WorkoutSession.deserializeBinaryFromReader);
      msg.setSession(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.CompleteWorkoutSessionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.CompleteWorkoutSessionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSession();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.WorkoutSession.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional WorkoutSession session = 1;
 * @return {?proto.fitness.service.v1.WorkoutSession}
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse.prototype.getSession = function() {
  return /** @type{?proto.fitness.service.v1.WorkoutSession} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.WorkoutSession, 1));
};


/**
 * @param {?proto.fitness.service.v1.WorkoutSession|undefined} value
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionResponse} returns this
*/
proto.fitness.service.v1.CompleteWorkoutSessionResponse.prototype.setSession = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionResponse} returns this
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse.prototype.clearSession = function() {
  return this.setSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse.prototype.hasSession = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.CompleteWorkoutSessionResponse} returns this
 */
proto.fitness.service.v1.CompleteWorkoutSessionResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetWorkoutSessionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetWorkoutSessionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
clientId: jspb.Message.getFieldWithDefault(msg, 1, ""),
groupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 5, ""),
page: jspb.Message.getFieldWithDefault(msg, 6, 0),
limit: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsRequest}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetWorkoutSessionsRequest;
  return proto.fitness.service.v1.GetWorkoutSessionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetWorkoutSessionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsRequest}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetWorkoutSessionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetWorkoutSessionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string client_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string group_id = 2;
 * @return {string}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp start_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsRequest} returns this
*/
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsRequest} returns this
*/
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 page = 6;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 limit = 7;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetWorkoutSessionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetWorkoutSessionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionsList: jspb.Message.toObjectList(msg.getSessionsList(),
    proto.fitness.service.v1.WorkoutSession.toObject, includeInstance),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsResponse}
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetWorkoutSessionsResponse;
  return proto.fitness.service.v1.GetWorkoutSessionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetWorkoutSessionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsResponse}
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.WorkoutSession;
      reader.readMessage(value,proto.fitness.service.v1.WorkoutSession.deserializeBinaryFromReader);
      msg.addSessions(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetWorkoutSessionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetWorkoutSessionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fitness.service.v1.WorkoutSession.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated WorkoutSession sessions = 1;
 * @return {!Array<!proto.fitness.service.v1.WorkoutSession>}
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.getSessionsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.WorkoutSession>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.WorkoutSession, 1));
};


/**
 * @param {!Array<!proto.fitness.service.v1.WorkoutSession>} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsResponse} returns this
*/
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.setSessionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fitness.service.v1.WorkoutSession=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.WorkoutSession}
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.addSessions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fitness.service.v1.WorkoutSession, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.clearSessionsList = function() {
  return this.setSessionsList([]);
};


/**
 * optional int32 total_count = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionsResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionsResponse.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetWorkoutSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetWorkoutSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetWorkoutSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionRequest}
 */
proto.fitness.service.v1.GetWorkoutSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetWorkoutSessionRequest;
  return proto.fitness.service.v1.GetWorkoutSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetWorkoutSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionRequest}
 */
proto.fitness.service.v1.GetWorkoutSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSessionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetWorkoutSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetWorkoutSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetWorkoutSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string session_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetWorkoutSessionRequest.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionRequest} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetWorkoutSessionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetWorkoutSessionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetWorkoutSessionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutSessionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
session: (f = msg.getSession()) && proto.fitness.service.v1.WorkoutSession.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionResponse}
 */
proto.fitness.service.v1.GetWorkoutSessionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetWorkoutSessionResponse;
  return proto.fitness.service.v1.GetWorkoutSessionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetWorkoutSessionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionResponse}
 */
proto.fitness.service.v1.GetWorkoutSessionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.WorkoutSession;
      reader.readMessage(value,proto.fitness.service.v1.WorkoutSession.deserializeBinaryFromReader);
      msg.setSession(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetWorkoutSessionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetWorkoutSessionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetWorkoutSessionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetWorkoutSessionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSession();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.WorkoutSession.serializeBinaryToWriter
    );
  }
};


/**
 * optional WorkoutSession session = 1;
 * @return {?proto.fitness.service.v1.WorkoutSession}
 */
proto.fitness.service.v1.GetWorkoutSessionResponse.prototype.getSession = function() {
  return /** @type{?proto.fitness.service.v1.WorkoutSession} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.WorkoutSession, 1));
};


/**
 * @param {?proto.fitness.service.v1.WorkoutSession|undefined} value
 * @return {!proto.fitness.service.v1.GetWorkoutSessionResponse} returns this
*/
proto.fitness.service.v1.GetWorkoutSessionResponse.prototype.setSession = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetWorkoutSessionResponse} returns this
 */
proto.fitness.service.v1.GetWorkoutSessionResponse.prototype.clearSession = function() {
  return this.setSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetWorkoutSessionResponse.prototype.hasSession = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.ExerciseProgress.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.ExerciseProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.ExerciseProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ExerciseProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
exerciseId: jspb.Message.getFieldWithDefault(msg, 1, ""),
exerciseName: jspb.Message.getFieldWithDefault(msg, 2, ""),
setsLogged: jspb.Message.getFieldWithDefault(msg, 3, 0),
bestWeightKg: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
bestReps: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalVolumeKg: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
lastPerformedAt: (f = msg.getLastPerformedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
pointsList: jspb.Message.toObjectList(msg.getPointsList(),
    proto.fitness.service.v1.ExercisePoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.ExerciseProgress}
 */
proto.fitness.service.v1.ExerciseProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.ExerciseProgress;
  return proto.fitness.service.v1.ExerciseProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.ExerciseProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.ExerciseProgress}
 */
proto.fitness.service.v1.ExerciseProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setExerciseName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSetsLogged(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBestWeightKg(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBestReps(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalVolumeKg(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastPerformedAt(value);
      break;
    case 8:
      var value = new proto.fitness.service.v1.ExercisePoint;
      reader.readMessage(value,proto.fitness.service.v1.ExercisePoint.deserializeBinaryFromReader);
      msg.addPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.ExerciseProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.ExerciseProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ExerciseProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExerciseId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExerciseName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSetsLogged();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBestWeightKg();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getBestReps();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTotalVolumeKg();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getLastPerformedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.fitness.service.v1.ExercisePoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional string exercise_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.getExerciseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ExerciseProgress} returns this
 */
proto.fitness.service.v1.ExerciseProgress.prototype.setExerciseId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string exercise_name = 2;
 * @return {string}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.getExerciseName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ExerciseProgress} returns this
 */
proto.fitness.service.v1.ExerciseProgress.prototype.setExerciseName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 sets_logged = 3;
 * @return {number}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.getSetsLogged = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ExerciseProgress} returns this
 */
proto.fitness.service.v1.ExerciseProgress.prototype.setSetsLogged = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double best_weight_kg = 4;
 * @return {number}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.getBestWeightKg = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ExerciseProgress} returns this
 */
proto.fitness.service.v1.ExerciseProgress.prototype.setBestWeightKg = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 best_reps = 5;
 * @return {number}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.getBestReps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ExerciseProgress} returns this
 */
proto.fitness.service.v1.ExerciseProgress.prototype.setBestReps = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double total_volume_kg = 6;
 * @return {number}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.getTotalVolumeKg = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ExerciseProgress} returns this
 */
proto.fitness.service.v1.ExerciseProgress.prototype.setTotalVolumeKg = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp last_performed_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.getLastPerformedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.ExerciseProgress} returns this
*/
proto.fitness.service.v1.ExerciseProgress.prototype.setLastPerformedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.ExerciseProgress} returns this
 */
proto.fitness.service.v1.ExerciseProgress.prototype.clearLastPerformedAt = function() {
  return this.setLastPerformedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.hasLastPerformedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated ExercisePoint points = 8;
 * @return {!Array<!proto.fitness.service.v1.ExercisePoint>}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.getPointsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.ExercisePoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.ExercisePoint, 8));
};


/**
 * @param {!Array<!proto.fitness.service.v1.ExercisePoint>} value
 * @return {!proto.fitness.service.v1.ExerciseProgress} returns this
*/
proto.fitness.service.v1.ExerciseProgress.prototype.setPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.fitness.service.v1.ExercisePoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.ExercisePoint}
 */
proto.fitness.service.v1.ExerciseProgress.prototype.addPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.fitness.service.v1.ExercisePoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.ExerciseProgress} returns this
 */
proto.fitness.service.v1.ExerciseProgress.prototype.clearPointsList = function() {
  return this.setPointsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.ExercisePoint.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.ExercisePoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.ExercisePoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ExercisePoint.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
bestWeightKg: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
reps: jspb.Message.getFieldWithDefault(msg, 3, 0),
sets: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.ExercisePoint}
 */
proto.fitness.service.v1.ExercisePoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.ExercisePoint;
  return proto.fitness.service.v1.ExercisePoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.ExercisePoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.ExercisePoint}
 */
proto.fitness.service.v1.ExercisePoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBestWeightKg(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReps(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.ExercisePoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.ExercisePoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.ExercisePoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ExercisePoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBestWeightKg();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getReps();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSets();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.fitness.service.v1.ExercisePoint.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ExercisePoint} returns this
 */
proto.fitness.service.v1.ExercisePoint.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double best_weight_kg = 2;
 * @return {number}
 */
proto.fitness.service.v1.ExercisePoint.prototype.getBestWeightKg = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ExercisePoint} returns this
 */
proto.fitness.service.v1.ExercisePoint.prototype.setBestWeightKg = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 reps = 3;
 * @return {number}
 */
proto.fitness.service.v1.ExercisePoint.prototype.getReps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ExercisePoint} returns this
 */
proto.fitness.service.v1.ExercisePoint.prototype.setReps = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 sets = 4;
 * @return {number}
 */
proto.fitness.service.v1.ExercisePoint.prototype.getSets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ExercisePoint} returns this
 */
proto.fitness.service.v1.ExercisePoint.prototype.setSets = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.ClientProgress.repeatedFields_ = [10,11,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.ClientProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.ClientProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.ClientProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ClientProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
clientId: jspb.Message.getFieldWithDefault(msg, 1, ""),
clientName: jspb.Message.getFieldWithDefault(msg, 2, ""),
sessionsCompleted: jspb.Message.getFieldWithDefault(msg, 3, 0),
sessionsScheduled: jspb.Message.getFieldWithDefault(msg, 4, 0),
adherencePercent: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalVolumeKg: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
totalDurationMinutes: jspb.Message.getFieldWithDefault(msg, 7, 0),
averageRpe: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
lastSessionAt: (f = msg.getLastSessionAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
exercisesList: jspb.Message.toObjectList(msg.getExercisesList(),
    proto.fitness.service.v1.ExerciseProgress.toObject, includeInstance),
recentSessionsList: jspb.Message.toObjectList(msg.getRecentSessionsList(),
    proto.fitness.service.v1.WorkoutSession.toObject, includeInstance),
daysTrained: jspb.Message.getFieldWithDefault(msg, 12, 0),
daysScheduled: jspb.Message.getFieldWithDefault(msg, 13, 0),
volumeByDayList: jspb.Message.toObjectList(msg.getVolumeByDayList(),
    proto.fitness.service.v1.DayVolume.toObject, includeInstance),
planEndsAt: (f = msg.getPlanEndsAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.ClientProgress}
 */
proto.fitness.service.v1.ClientProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.ClientProgress;
  return proto.fitness.service.v1.ClientProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.ClientProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.ClientProgress}
 */
proto.fitness.service.v1.ClientProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSessionsCompleted(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSessionsScheduled(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAdherencePercent(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalVolumeKg(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalDurationMinutes(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAverageRpe(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastSessionAt(value);
      break;
    case 10:
      var value = new proto.fitness.service.v1.ExerciseProgress;
      reader.readMessage(value,proto.fitness.service.v1.ExerciseProgress.deserializeBinaryFromReader);
      msg.addExercises(value);
      break;
    case 11:
      var value = new proto.fitness.service.v1.WorkoutSession;
      reader.readMessage(value,proto.fitness.service.v1.WorkoutSession.deserializeBinaryFromReader);
      msg.addRecentSessions(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDaysTrained(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDaysScheduled(value);
      break;
    case 14:
      var value = new proto.fitness.service.v1.DayVolume;
      reader.readMessage(value,proto.fitness.service.v1.DayVolume.deserializeBinaryFromReader);
      msg.addVolumeByDay(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPlanEndsAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.ClientProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.ClientProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.ClientProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.ClientProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSessionsCompleted();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSessionsScheduled();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAdherencePercent();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTotalVolumeKg();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getTotalDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getAverageRpe();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getLastSessionAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExercisesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.fitness.service.v1.ExerciseProgress.serializeBinaryToWriter
    );
  }
  f = message.getRecentSessionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.fitness.service.v1.WorkoutSession.serializeBinaryToWriter
    );
  }
  f = message.getDaysTrained();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getDaysScheduled();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getVolumeByDayList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.fitness.service.v1.DayVolume.serializeBinaryToWriter
    );
  }
  f = message.getPlanEndsAt();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string client_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.ClientProgress.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_name = 2;
 * @return {string}
 */
proto.fitness.service.v1.ClientProgress.prototype.getClientName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.setClientName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 sessions_completed = 3;
 * @return {number}
 */
proto.fitness.service.v1.ClientProgress.prototype.getSessionsCompleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.setSessionsCompleted = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 sessions_scheduled = 4;
 * @return {number}
 */
proto.fitness.service.v1.ClientProgress.prototype.getSessionsScheduled = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.setSessionsScheduled = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 adherence_percent = 5;
 * @return {number}
 */
proto.fitness.service.v1.ClientProgress.prototype.getAdherencePercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.setAdherencePercent = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double total_volume_kg = 6;
 * @return {number}
 */
proto.fitness.service.v1.ClientProgress.prototype.getTotalVolumeKg = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.setTotalVolumeKg = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int32 total_duration_minutes = 7;
 * @return {number}
 */
proto.fitness.service.v1.ClientProgress.prototype.getTotalDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.setTotalDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional double average_rpe = 8;
 * @return {number}
 */
proto.fitness.service.v1.ClientProgress.prototype.getAverageRpe = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.setAverageRpe = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp last_session_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.ClientProgress.prototype.getLastSessionAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
*/
proto.fitness.service.v1.ClientProgress.prototype.setLastSessionAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.clearLastSessionAt = function() {
  return this.setLastSessionAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.ClientProgress.prototype.hasLastSessionAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * repeated ExerciseProgress exercises = 10;
 * @return {!Array<!proto.fitness.service.v1.ExerciseProgress>}
 */
proto.fitness.service.v1.ClientProgress.prototype.getExercisesList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.ExerciseProgress>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.ExerciseProgress, 10));
};


/**
 * @param {!Array<!proto.fitness.service.v1.ExerciseProgress>} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
*/
proto.fitness.service.v1.ClientProgress.prototype.setExercisesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.fitness.service.v1.ExerciseProgress=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.ExerciseProgress}
 */
proto.fitness.service.v1.ClientProgress.prototype.addExercises = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.fitness.service.v1.ExerciseProgress, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.clearExercisesList = function() {
  return this.setExercisesList([]);
};


/**
 * repeated WorkoutSession recent_sessions = 11;
 * @return {!Array<!proto.fitness.service.v1.WorkoutSession>}
 */
proto.fitness.service.v1.ClientProgress.prototype.getRecentSessionsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.WorkoutSession>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.WorkoutSession, 11));
};


/**
 * @param {!Array<!proto.fitness.service.v1.WorkoutSession>} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
*/
proto.fitness.service.v1.ClientProgress.prototype.setRecentSessionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.fitness.service.v1.WorkoutSession=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.WorkoutSession}
 */
proto.fitness.service.v1.ClientProgress.prototype.addRecentSessions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.fitness.service.v1.WorkoutSession, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.clearRecentSessionsList = function() {
  return this.setRecentSessionsList([]);
};


/**
 * optional int32 days_trained = 12;
 * @return {number}
 */
proto.fitness.service.v1.ClientProgress.prototype.getDaysTrained = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.setDaysTrained = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 days_scheduled = 13;
 * @return {number}
 */
proto.fitness.service.v1.ClientProgress.prototype.getDaysScheduled = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.setDaysScheduled = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * repeated DayVolume volume_by_day = 14;
 * @return {!Array<!proto.fitness.service.v1.DayVolume>}
 */
proto.fitness.service.v1.ClientProgress.prototype.getVolumeByDayList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.DayVolume>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.DayVolume, 14));
};


/**
 * @param {!Array<!proto.fitness.service.v1.DayVolume>} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
*/
proto.fitness.service.v1.ClientProgress.prototype.setVolumeByDayList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.fitness.service.v1.DayVolume=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.DayVolume}
 */
proto.fitness.service.v1.ClientProgress.prototype.addVolumeByDay = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.fitness.service.v1.DayVolume, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.clearVolumeByDayList = function() {
  return this.setVolumeByDayList([]);
};


/**
 * optional google.protobuf.Timestamp plan_ends_at = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.ClientProgress.prototype.getPlanEndsAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
*/
proto.fitness.service.v1.ClientProgress.prototype.setPlanEndsAt = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.ClientProgress} returns this
 */
proto.fitness.service.v1.ClientProgress.prototype.clearPlanEndsAt = function() {
  return this.setPlanEndsAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.ClientProgress.prototype.hasPlanEndsAt = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.DayVolume.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.DayVolume.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.DayVolume} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DayVolume.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
volumeKg: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
sessions: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.DayVolume}
 */
proto.fitness.service.v1.DayVolume.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.DayVolume;
  return proto.fitness.service.v1.DayVolume.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.DayVolume} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.DayVolume}
 */
proto.fitness.service.v1.DayVolume.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVolumeKg(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSessions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.DayVolume.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.DayVolume.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.DayVolume} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.DayVolume.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVolumeKg();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getSessions();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.fitness.service.v1.DayVolume.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.DayVolume} returns this
 */
proto.fitness.service.v1.DayVolume.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double volume_kg = 2;
 * @return {number}
 */
proto.fitness.service.v1.DayVolume.prototype.getVolumeKg = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.DayVolume} returns this
 */
proto.fitness.service.v1.DayVolume.prototype.setVolumeKg = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 sessions = 3;
 * @return {number}
 */
proto.fitness.service.v1.DayVolume.prototype.getSessions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.DayVolume} returns this
 */
proto.fitness.service.v1.DayVolume.prototype.setSessions = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetClientProgressRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetClientProgressRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetClientProgressRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetClientProgressRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
clientId: jspb.Message.getFieldWithDefault(msg, 1, ""),
startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetClientProgressRequest}
 */
proto.fitness.service.v1.GetClientProgressRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetClientProgressRequest;
  return proto.fitness.service.v1.GetClientProgressRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetClientProgressRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetClientProgressRequest}
 */
proto.fitness.service.v1.GetClientProgressRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setClientId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetClientProgressRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetClientProgressRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetClientProgressRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetClientProgressRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string client_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetClientProgressRequest.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetClientProgressRequest} returns this
 */
proto.fitness.service.v1.GetClientProgressRequest.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp start_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.GetClientProgressRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.GetClientProgressRequest} returns this
*/
proto.fitness.service.v1.GetClientProgressRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetClientProgressRequest} returns this
 */
proto.fitness.service.v1.GetClientProgressRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetClientProgressRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.GetClientProgressRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.GetClientProgressRequest} returns this
*/
proto.fitness.service.v1.GetClientProgressRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetClientProgressRequest} returns this
 */
proto.fitness.service.v1.GetClientProgressRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetClientProgressRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetClientProgressResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetClientProgressResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetClientProgressResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetClientProgressResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
progress: (f = msg.getProgress()) && proto.fitness.service.v1.ClientProgress.toObject(includeInstance, f),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetClientProgressResponse}
 */
proto.fitness.service.v1.GetClientProgressResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetClientProgressResponse;
  return proto.fitness.service.v1.GetClientProgressResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetClientProgressResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetClientProgressResponse}
 */
proto.fitness.service.v1.GetClientProgressResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fitness.service.v1.ClientProgress;
      reader.readMessage(value,proto.fitness.service.v1.ClientProgress.deserializeBinaryFromReader);
      msg.setProgress(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetClientProgressResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetClientProgressResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetClientProgressResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetClientProgressResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProgress();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fitness.service.v1.ClientProgress.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ClientProgress progress = 1;
 * @return {?proto.fitness.service.v1.ClientProgress}
 */
proto.fitness.service.v1.GetClientProgressResponse.prototype.getProgress = function() {
  return /** @type{?proto.fitness.service.v1.ClientProgress} */ (
    jspb.Message.getWrapperField(this, proto.fitness.service.v1.ClientProgress, 1));
};


/**
 * @param {?proto.fitness.service.v1.ClientProgress|undefined} value
 * @return {!proto.fitness.service.v1.GetClientProgressResponse} returns this
*/
proto.fitness.service.v1.GetClientProgressResponse.prototype.setProgress = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetClientProgressResponse} returns this
 */
proto.fitness.service.v1.GetClientProgressResponse.prototype.clearProgress = function() {
  return this.setProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetClientProgressResponse.prototype.hasProgress = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.fitness.service.v1.GetClientProgressResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetClientProgressResponse} returns this
 */
proto.fitness.service.v1.GetClientProgressResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetGroupProgressRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetGroupProgressRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetGroupProgressRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupProgressRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetGroupProgressRequest}
 */
proto.fitness.service.v1.GetGroupProgressRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetGroupProgressRequest;
  return proto.fitness.service.v1.GetGroupProgressRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetGroupProgressRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetGroupProgressRequest}
 */
proto.fitness.service.v1.GetGroupProgressRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetGroupProgressRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetGroupProgressRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetGroupProgressRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupProgressRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetGroupProgressRequest.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetGroupProgressRequest} returns this
 */
proto.fitness.service.v1.GetGroupProgressRequest.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp start_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.GetGroupProgressRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.GetGroupProgressRequest} returns this
*/
proto.fitness.service.v1.GetGroupProgressRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetGroupProgressRequest} returns this
 */
proto.fitness.service.v1.GetGroupProgressRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetGroupProgressRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.GetGroupProgressRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.GetGroupProgressRequest} returns this
*/
proto.fitness.service.v1.GetGroupProgressRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetGroupProgressRequest} returns this
 */
proto.fitness.service.v1.GetGroupProgressRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetGroupProgressRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetGroupProgressResponse.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetGroupProgressResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetGroupProgressResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupProgressResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
groupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
groupName: jspb.Message.getFieldWithDefault(msg, 2, ""),
memberCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
sessionsCompleted: jspb.Message.getFieldWithDefault(msg, 4, 0),
groupAdherencePercent: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalVolumeKg: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.fitness.service.v1.ClientProgress.toObject, includeInstance),
message: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetGroupProgressResponse}
 */
proto.fitness.service.v1.GetGroupProgressResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetGroupProgressResponse;
  return proto.fitness.service.v1.GetGroupProgressResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetGroupProgressResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetGroupProgressResponse}
 */
proto.fitness.service.v1.GetGroupProgressResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGroupName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSessionsCompleted(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGroupAdherencePercent(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalVolumeKg(value);
      break;
    case 7:
      var value = new proto.fitness.service.v1.ClientProgress;
      reader.readMessage(value,proto.fitness.service.v1.ClientProgress.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetGroupProgressResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetGroupProgressResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetGroupProgressResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMemberCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSessionsCompleted();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getGroupAdherencePercent();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTotalVolumeKg();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.fitness.service.v1.ClientProgress.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string group_id = 1;
 * @return {string}
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetGroupProgressResponse} returns this
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string group_name = 2;
 * @return {string}
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.getGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetGroupProgressResponse} returns this
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.setGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 member_count = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.getMemberCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetGroupProgressResponse} returns this
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.setMemberCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 sessions_completed = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.getSessionsCompleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetGroupProgressResponse} returns this
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.setSessionsCompleted = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 group_adherence_percent = 5;
 * @return {number}
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.getGroupAdherencePercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetGroupProgressResponse} returns this
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.setGroupAdherencePercent = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double total_volume_kg = 6;
 * @return {number}
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.getTotalVolumeKg = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetGroupProgressResponse} returns this
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.setTotalVolumeKg = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * repeated ClientProgress members = 7;
 * @return {!Array<!proto.fitness.service.v1.ClientProgress>}
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.ClientProgress>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.ClientProgress, 7));
};


/**
 * @param {!Array<!proto.fitness.service.v1.ClientProgress>} value
 * @return {!proto.fitness.service.v1.GetGroupProgressResponse} returns this
*/
proto.fitness.service.v1.GetGroupProgressResponse.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.fitness.service.v1.ClientProgress=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.ClientProgress}
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.fitness.service.v1.ClientProgress, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetGroupProgressResponse} returns this
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * optional string message = 8;
 * @return {string}
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fitness.service.v1.GetGroupProgressResponse} returns this
 */
proto.fitness.service.v1.GetGroupProgressResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetRosterProgressRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetRosterProgressRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetRosterProgressRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetRosterProgressRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetRosterProgressRequest}
 */
proto.fitness.service.v1.GetRosterProgressRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetRosterProgressRequest;
  return proto.fitness.service.v1.GetRosterProgressRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetRosterProgressRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetRosterProgressRequest}
 */
proto.fitness.service.v1.GetRosterProgressRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetRosterProgressRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetRosterProgressRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetRosterProgressRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetRosterProgressRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.GetRosterProgressRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.GetRosterProgressRequest} returns this
*/
proto.fitness.service.v1.GetRosterProgressRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetRosterProgressRequest} returns this
 */
proto.fitness.service.v1.GetRosterProgressRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetRosterProgressRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fitness.service.v1.GetRosterProgressRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fitness.service.v1.GetRosterProgressRequest} returns this
*/
proto.fitness.service.v1.GetRosterProgressRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fitness.service.v1.GetRosterProgressRequest} returns this
 */
proto.fitness.service.v1.GetRosterProgressRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fitness.service.v1.GetRosterProgressRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fitness.service.v1.GetRosterProgressResponse.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fitness.service.v1.GetRosterProgressResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fitness.service.v1.GetRosterProgressResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetRosterProgressResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
clientCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
sessionsCompleted: jspb.Message.getFieldWithDefault(msg, 2, 0),
rosterAdherencePercent: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalVolumeKg: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
totalDurationMinutes: jspb.Message.getFieldWithDefault(msg, 5, 0),
clientsList: jspb.Message.toObjectList(msg.getClientsList(),
    proto.fitness.service.v1.ClientProgress.toObject, includeInstance),
volumeByDayList: jspb.Message.toObjectList(msg.getVolumeByDayList(),
    proto.fitness.service.v1.DayVolume.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fitness.service.v1.GetRosterProgressResponse}
 */
proto.fitness.service.v1.GetRosterProgressResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fitness.service.v1.GetRosterProgressResponse;
  return proto.fitness.service.v1.GetRosterProgressResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fitness.service.v1.GetRosterProgressResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fitness.service.v1.GetRosterProgressResponse}
 */
proto.fitness.service.v1.GetRosterProgressResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClientCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSessionsCompleted(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRosterAdherencePercent(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalVolumeKg(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalDurationMinutes(value);
      break;
    case 6:
      var value = new proto.fitness.service.v1.ClientProgress;
      reader.readMessage(value,proto.fitness.service.v1.ClientProgress.deserializeBinaryFromReader);
      msg.addClients(value);
      break;
    case 7:
      var value = new proto.fitness.service.v1.DayVolume;
      reader.readMessage(value,proto.fitness.service.v1.DayVolume.deserializeBinaryFromReader);
      msg.addVolumeByDay(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fitness.service.v1.GetRosterProgressResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fitness.service.v1.GetRosterProgressResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fitness.service.v1.GetRosterProgressResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSessionsCompleted();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRosterAdherencePercent();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalVolumeKg();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTotalDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getClientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.fitness.service.v1.ClientProgress.serializeBinaryToWriter
    );
  }
  f = message.getVolumeByDayList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.fitness.service.v1.DayVolume.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 client_count = 1;
 * @return {number}
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.getClientCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetRosterProgressResponse} returns this
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.setClientCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 sessions_completed = 2;
 * @return {number}
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.getSessionsCompleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetRosterProgressResponse} returns this
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.setSessionsCompleted = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 roster_adherence_percent = 3;
 * @return {number}
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.getRosterAdherencePercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetRosterProgressResponse} returns this
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.setRosterAdherencePercent = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double total_volume_kg = 4;
 * @return {number}
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.getTotalVolumeKg = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetRosterProgressResponse} returns this
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.setTotalVolumeKg = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 total_duration_minutes = 5;
 * @return {number}
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.getTotalDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fitness.service.v1.GetRosterProgressResponse} returns this
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.setTotalDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated ClientProgress clients = 6;
 * @return {!Array<!proto.fitness.service.v1.ClientProgress>}
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.getClientsList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.ClientProgress>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.ClientProgress, 6));
};


/**
 * @param {!Array<!proto.fitness.service.v1.ClientProgress>} value
 * @return {!proto.fitness.service.v1.GetRosterProgressResponse} returns this
*/
proto.fitness.service.v1.GetRosterProgressResponse.prototype.setClientsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.fitness.service.v1.ClientProgress=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.ClientProgress}
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.addClients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.fitness.service.v1.ClientProgress, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetRosterProgressResponse} returns this
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.clearClientsList = function() {
  return this.setClientsList([]);
};


/**
 * repeated DayVolume volume_by_day = 7;
 * @return {!Array<!proto.fitness.service.v1.DayVolume>}
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.getVolumeByDayList = function() {
  return /** @type{!Array<!proto.fitness.service.v1.DayVolume>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fitness.service.v1.DayVolume, 7));
};


/**
 * @param {!Array<!proto.fitness.service.v1.DayVolume>} value
 * @return {!proto.fitness.service.v1.GetRosterProgressResponse} returns this
*/
proto.fitness.service.v1.GetRosterProgressResponse.prototype.setVolumeByDayList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.fitness.service.v1.DayVolume=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fitness.service.v1.DayVolume}
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.addVolumeByDay = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.fitness.service.v1.DayVolume, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fitness.service.v1.GetRosterProgressResponse} returns this
 */
proto.fitness.service.v1.GetRosterProgressResponse.prototype.clearVolumeByDayList = function() {
  return this.setVolumeByDayList([]);
};


goog.object.extend(exports, proto.fitness.service.v1);
